/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Bookie - Martial Arts Private Lesson Scheduling SaaS API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptTrainerInviteInput,
  AcceptTrainerInviteResponse,
  AddStudentGymBody,
  AdminDashboard,
  AiAssistantConfig,
  AmendSessionInput,
  AuthResponse,
  AutoRenewInput,
  AvailabilityBlock,
  BillingStatus,
  BrandingConfig,
  BulkSetAvailabilityBody,
  CalendarEvent,
  CancelTrainerInvite200,
  CancellationPolicy,
  ChatChannel,
  ChatTokenResponse,
  CheckoutClassBody,
  CheckoutResponse,
  CheckoutSessionBody,
  ClassEnrollment,
  CompleteStripeConnect200,
  CompleteStudentOnboarding200,
  CopyLocationSchedule200,
  CreateAvailabilityInput,
  CreateClassInput,
  CreateLocationAvailabilityInput,
  CreateLocationInput,
  CreateMembershipPlanInput,
  CreatePackageInput,
  CreateRatingInput,
  CreateSessionInput,
  CreateTrainerClientRateBody,
  CreateTrainerInput,
  CreateTrainerMessageTemplateBody,
  DeleteTrainer200,
  DeleteTrainerClientRate200,
  EnrollInput,
  GetAdminCalendarParams,
  GetAdminCalendarTrainerAvailabilityParams,
  GetAdminLoginAttackHistoryParams,
  GetAdminPayrollParams,
  GetAnalyticsPeakHoursParams,
  GetAnalyticsRevenueBreakdownParams,
  GetGymScheduleSync200,
  GetGymSessionsParams,
  GetMySessionsParams,
  GetOpenSlotsParams,
  GetStudentMasterCalendarParams,
  GetTrainerAvailabilityParams,
  GetTrainerStudents200Item,
  GroupClass,
  Gym,
  GymPublicProfile,
  GymStripeConnectComplete200,
  GymStripeConnectRefresh200,
  HealthStatus,
  InviteTrainerInput,
  JoinSlotWaitlistBody,
  ListClassesParams,
  ListPublicTrainersParams,
  ListTrainersParams,
  Location,
  LocationAvailabilityBlock,
  LoginAttackHistoryEntry,
  LoginInput,
  MasterCalendarResponse,
  Membership,
  MembershipCheckoutBody,
  MembershipPlan,
  MessageResponse,
  Notification,
  OnboardGymInput,
  OnboardGymResponse,
  PackagePurchase,
  PayoutBatch,
  PayrollEntry,
  PeakHoursData,
  PlatformRevenue,
  PricingPolicy,
  PrivateSession,
  PublicGym,
  PublicTrainer,
  PurchasePackageInput,
  Rating,
  RefreshStripeConnect200,
  RegisterInput,
  RejectSessionBody,
  RespondToAmendmentBody,
  RevenueBreakdown,
  SearchAssistantInput,
  SearchAssistantResponse,
  SendClientSmsBody,
  SessionPackage,
  SlotWaitlistEntry,
  SlotWaitlistEntryWithTrainer,
  SlugCheckResponse,
  SmsResult,
  StudentGymEntry,
  SuccessResponse,
  SuperadminDashboard,
  TimeSlot,
  ToggleLocationActiveBody,
  TokenResponse,
  TrainerAvailabilitySlot,
  TrainerClient,
  TrainerClientRate,
  TrainerInvite,
  TrainerInviteDetails,
  TrainerMessageTemplate,
  TrainerProfile,
  TrainerPublicProfile,
  TrainerUtilization,
  UpdateAvailabilityInput,
  UpdateClassInput,
  UpdateGymInput,
  UpdateGymScheduleSync200,
  UpdateGymScheduleSyncBody,
  UpdateLocationAvailabilityInput,
  UpdateLocationInput,
  UpdateMembershipPlanInput,
  UpdateNotificationPreferencesBody,
  UpdatePackageInput,
  UpdateTrainerAdminInput,
  UpdateTrainerLocationsBody,
  UpdateTrainerMessageTemplateBody,
  UpdateTrainerProfileInput,
  UpdateTrainerRateBody,
  UserProfile,
  WaitlistEntry,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new user
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerInput: RegisterInput,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerInput),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterInput> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterInput> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterInput>;
export type RegisterMutationError = ErrorType<unknown>;

/**
 * @summary Register a new user
 */
export const useRegister = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterInput> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginInput: LoginInput,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginInput),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginInput> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginInput> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginInput>;
export type LoginMutationError = ErrorType<unknown>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginInput> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Refresh access token
 */
export const getRefreshTokenUrl = () => {
  return `/api/auth/refresh`;
};

export const refreshToken = async (
  options?: RequestInit,
): Promise<TokenResponse> => {
  return customFetch<TokenResponse>(getRefreshTokenUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    void
  > = () => {
    return refreshToken(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshToken>>
>;

export type RefreshTokenMutationError = ErrorType<unknown>;

/**
 * @summary Refresh access token
 */
export const useRefreshToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshTokenMutationOptions(options));
};

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get current user profile
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<unknown>;

/**
 * @summary Get current user profile
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Self-serve gym registration
 */
export const getOnboardGymUrl = () => {
  return `/api/onboarding/gym`;
};

export const onboardGym = async (
  onboardGymInput: OnboardGymInput,
  options?: RequestInit,
): Promise<OnboardGymResponse> => {
  return customFetch<OnboardGymResponse>(getOnboardGymUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(onboardGymInput),
  });
};

export const getOnboardGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardGym>>,
    TError,
    { data: BodyType<OnboardGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardGym>>,
  TError,
  { data: BodyType<OnboardGymInput> },
  TContext
> => {
  const mutationKey = ["onboardGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardGym>>,
    { data: BodyType<OnboardGymInput> }
  > = (props) => {
    const { data } = props ?? {};

    return onboardGym(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardGym>>
>;
export type OnboardGymMutationBody = BodyType<OnboardGymInput>;
export type OnboardGymMutationError = ErrorType<unknown>;

/**
 * @summary Self-serve gym registration
 */
export const useOnboardGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardGym>>,
    TError,
    { data: BodyType<OnboardGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof onboardGym>>,
  TError,
  { data: BodyType<OnboardGymInput> },
  TContext
> => {
  return useMutation(getOnboardGymMutationOptions(options));
};

/**
 * @summary Check gym slug availability
 */
export const getCheckGymSlugUrl = (slug: string) => {
  return `/api/onboarding/gym-check/${slug}`;
};

export const checkGymSlug = async (
  slug: string,
  options?: RequestInit,
): Promise<SlugCheckResponse> => {
  return customFetch<SlugCheckResponse>(getCheckGymSlugUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getCheckGymSlugQueryKey = (slug: string) => {
  return [`/api/onboarding/gym-check/${slug}`] as const;
};

export const getCheckGymSlugQueryOptions = <
  TData = Awaited<ReturnType<typeof checkGymSlug>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkGymSlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckGymSlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkGymSlug>>> = ({
    signal,
  }) => checkGymSlug(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkGymSlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckGymSlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkGymSlug>>
>;
export type CheckGymSlugQueryError = ErrorType<unknown>;

/**
 * @summary Check gym slug availability
 */

export function useCheckGymSlug<
  TData = Awaited<ReturnType<typeof checkGymSlug>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkGymSlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckGymSlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark student onboarding as complete
 */
export const getCompleteStudentOnboardingUrl = () => {
  return `/api/onboarding/student/complete`;
};

export const completeStudentOnboarding = async (
  options?: RequestInit,
): Promise<CompleteStudentOnboarding200> => {
  return customFetch<CompleteStudentOnboarding200>(
    getCompleteStudentOnboardingUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCompleteStudentOnboardingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeStudentOnboarding>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeStudentOnboarding>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["completeStudentOnboarding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeStudentOnboarding>>,
    void
  > = () => {
    return completeStudentOnboarding(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteStudentOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeStudentOnboarding>>
>;

export type CompleteStudentOnboardingMutationError = ErrorType<unknown>;

/**
 * @summary Mark student onboarding as complete
 */
export const useCompleteStudentOnboarding = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeStudentOnboarding>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeStudentOnboarding>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCompleteStudentOnboardingMutationOptions(options));
};

/**
 * @summary Public gym directory
 */
export const getListPublicGymsUrl = () => {
  return `/api/onboarding/gyms`;
};

export const listPublicGyms = async (
  options?: RequestInit,
): Promise<PublicGym[]> => {
  return customFetch<PublicGym[]>(getListPublicGymsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPublicGymsQueryKey = () => {
  return [`/api/onboarding/gyms`] as const;
};

export const getListPublicGymsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPublicGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPublicGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPublicGymsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicGyms>>> = ({
    signal,
  }) => listPublicGyms({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPublicGyms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPublicGymsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPublicGyms>>
>;
export type ListPublicGymsQueryError = ErrorType<unknown>;

/**
 * @summary Public gym directory
 */

export function useListPublicGyms<
  TData = Awaited<ReturnType<typeof listPublicGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPublicGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPublicGymsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public gym info with trainers and locations
 */
export const getGetGymPublicUrl = (slug: string) => {
  return `/api/gyms/${slug}/public`;
};

export const getGymPublic = async (
  slug: string,
  options?: RequestInit,
): Promise<GymPublicProfile> => {
  return customFetch<GymPublicProfile>(getGetGymPublicUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetGymPublicQueryKey = (slug: string) => {
  return [`/api/gyms/${slug}/public`] as const;
};

export const getGetGymPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymPublic>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPublic>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymPublicQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGymPublic>>> = ({
    signal,
  }) => getGymPublic(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymPublic>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymPublic>>
>;
export type GetGymPublicQueryError = ErrorType<unknown>;

/**
 * @summary Public gym info with trainers and locations
 */

export function useGetGymPublic<
  TData = Awaited<ReturnType<typeof getGymPublic>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPublic>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymPublicQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update gym info
 */
export const getUpdateGymUrl = (id: string) => {
  return `/api/gyms/${id}`;
};

export const updateGym = async (
  id: string,
  updateGymInput: UpdateGymInput,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getUpdateGymUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGymInput),
  });
};

export const getUpdateGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGym>>,
    TError,
    { id: string; data: BodyType<UpdateGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGym>>,
  TError,
  { id: string; data: BodyType<UpdateGymInput> },
  TContext
> => {
  const mutationKey = ["updateGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGym>>,
    { id: string; data: BodyType<UpdateGymInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGym(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGym>>
>;
export type UpdateGymMutationBody = BodyType<UpdateGymInput>;
export type UpdateGymMutationError = ErrorType<unknown>;

/**
 * @summary Update gym info
 */
export const useUpdateGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGym>>,
    TError,
    { id: string; data: BodyType<UpdateGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGym>>,
  TError,
  { id: string; data: BodyType<UpdateGymInput> },
  TContext
> => {
  return useMutation(getUpdateGymMutationOptions(options));
};

/**
 * @summary Get gym pricing policy
 */
export const getGetGymPricingPolicyUrl = (id: string) => {
  return `/api/gyms/${id}/pricing-policy`;
};

export const getGymPricingPolicy = async (
  id: string,
  options?: RequestInit,
): Promise<PricingPolicy> => {
  return customFetch<PricingPolicy>(getGetGymPricingPolicyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymPricingPolicyQueryKey = (id: string) => {
  return [`/api/gyms/${id}/pricing-policy`] as const;
};

export const getGetGymPricingPolicyQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymPricingPolicy>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPricingPolicy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymPricingPolicyQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymPricingPolicy>>
  > = ({ signal }) => getGymPricingPolicy(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymPricingPolicy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymPricingPolicyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymPricingPolicy>>
>;
export type GetGymPricingPolicyQueryError = ErrorType<unknown>;

/**
 * @summary Get gym pricing policy
 */

export function useGetGymPricingPolicy<
  TData = Awaited<ReturnType<typeof getGymPricingPolicy>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPricingPolicy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymPricingPolicyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update gym pricing policy
 */
export const getUpdateGymPricingPolicyUrl = (id: string) => {
  return `/api/gyms/${id}/pricing-policy`;
};

export const updateGymPricingPolicy = async (
  id: string,
  pricingPolicy: PricingPolicy,
  options?: RequestInit,
): Promise<PricingPolicy> => {
  return customFetch<PricingPolicy>(getUpdateGymPricingPolicyUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pricingPolicy),
  });
};

export const getUpdateGymPricingPolicyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymPricingPolicy>>,
    TError,
    { id: string; data: BodyType<PricingPolicy> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGymPricingPolicy>>,
  TError,
  { id: string; data: BodyType<PricingPolicy> },
  TContext
> => {
  const mutationKey = ["updateGymPricingPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGymPricingPolicy>>,
    { id: string; data: BodyType<PricingPolicy> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGymPricingPolicy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymPricingPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGymPricingPolicy>>
>;
export type UpdateGymPricingPolicyMutationBody = BodyType<PricingPolicy>;
export type UpdateGymPricingPolicyMutationError = ErrorType<unknown>;

/**
 * @summary Update gym pricing policy
 */
export const useUpdateGymPricingPolicy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymPricingPolicy>>,
    TError,
    { id: string; data: BodyType<PricingPolicy> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGymPricingPolicy>>,
  TError,
  { id: string; data: BodyType<PricingPolicy> },
  TContext
> => {
  return useMutation(getUpdateGymPricingPolicyMutationOptions(options));
};

/**
 * @summary Get cancellation policy
 */
export const getGetGymCancellationPolicyUrl = (id: string) => {
  return `/api/gyms/${id}/cancellation-policy`;
};

export const getGymCancellationPolicy = async (
  id: string,
  options?: RequestInit,
): Promise<CancellationPolicy> => {
  return customFetch<CancellationPolicy>(getGetGymCancellationPolicyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymCancellationPolicyQueryKey = (id: string) => {
  return [`/api/gyms/${id}/cancellation-policy`] as const;
};

export const getGetGymCancellationPolicyQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymCancellationPolicy>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymCancellationPolicy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymCancellationPolicyQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymCancellationPolicy>>
  > = ({ signal }) =>
    getGymCancellationPolicy(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymCancellationPolicy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymCancellationPolicyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymCancellationPolicy>>
>;
export type GetGymCancellationPolicyQueryError = ErrorType<unknown>;

/**
 * @summary Get cancellation policy
 */

export function useGetGymCancellationPolicy<
  TData = Awaited<ReturnType<typeof getGymCancellationPolicy>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymCancellationPolicy>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymCancellationPolicyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update cancellation policy
 */
export const getUpdateGymCancellationPolicyUrl = (id: string) => {
  return `/api/gyms/${id}/cancellation-policy`;
};

export const updateGymCancellationPolicy = async (
  id: string,
  cancellationPolicy: CancellationPolicy,
  options?: RequestInit,
): Promise<CancellationPolicy> => {
  return customFetch<CancellationPolicy>(
    getUpdateGymCancellationPolicyUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(cancellationPolicy),
    },
  );
};

export const getUpdateGymCancellationPolicyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymCancellationPolicy>>,
    TError,
    { id: string; data: BodyType<CancellationPolicy> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGymCancellationPolicy>>,
  TError,
  { id: string; data: BodyType<CancellationPolicy> },
  TContext
> => {
  const mutationKey = ["updateGymCancellationPolicy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGymCancellationPolicy>>,
    { id: string; data: BodyType<CancellationPolicy> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGymCancellationPolicy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymCancellationPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGymCancellationPolicy>>
>;
export type UpdateGymCancellationPolicyMutationBody =
  BodyType<CancellationPolicy>;
export type UpdateGymCancellationPolicyMutationError = ErrorType<unknown>;

/**
 * @summary Update cancellation policy
 */
export const useUpdateGymCancellationPolicy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymCancellationPolicy>>,
    TError,
    { id: string; data: BodyType<CancellationPolicy> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGymCancellationPolicy>>,
  TError,
  { id: string; data: BodyType<CancellationPolicy> },
  TContext
> => {
  return useMutation(getUpdateGymCancellationPolicyMutationOptions(options));
};

/**
 * @summary Get white-label branding config
 */
export const getGetGymBrandingUrl = (id: string) => {
  return `/api/gyms/${id}/branding`;
};

export const getGymBranding = async (
  id: string,
  options?: RequestInit,
): Promise<BrandingConfig> => {
  return customFetch<BrandingConfig>(getGetGymBrandingUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymBrandingQueryKey = (id: string) => {
  return [`/api/gyms/${id}/branding`] as const;
};

export const getGetGymBrandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymBranding>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymBranding>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymBrandingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGymBranding>>> = ({
    signal,
  }) => getGymBranding(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymBranding>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymBrandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymBranding>>
>;
export type GetGymBrandingQueryError = ErrorType<unknown>;

/**
 * @summary Get white-label branding config
 */

export function useGetGymBranding<
  TData = Awaited<ReturnType<typeof getGymBranding>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymBranding>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymBrandingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update white-label branding
 */
export const getUpdateGymBrandingUrl = (id: string) => {
  return `/api/gyms/${id}/branding`;
};

export const updateGymBranding = async (
  id: string,
  brandingConfig: BrandingConfig,
  options?: RequestInit,
): Promise<BrandingConfig> => {
  return customFetch<BrandingConfig>(getUpdateGymBrandingUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(brandingConfig),
  });
};

export const getUpdateGymBrandingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymBranding>>,
    TError,
    { id: string; data: BodyType<BrandingConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGymBranding>>,
  TError,
  { id: string; data: BodyType<BrandingConfig> },
  TContext
> => {
  const mutationKey = ["updateGymBranding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGymBranding>>,
    { id: string; data: BodyType<BrandingConfig> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGymBranding(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymBrandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGymBranding>>
>;
export type UpdateGymBrandingMutationBody = BodyType<BrandingConfig>;
export type UpdateGymBrandingMutationError = ErrorType<unknown>;

/**
 * @summary Update white-label branding
 */
export const useUpdateGymBranding = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymBranding>>,
    TError,
    { id: string; data: BodyType<BrandingConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGymBranding>>,
  TError,
  { id: string; data: BodyType<BrandingConfig> },
  TContext
> => {
  return useMutation(getUpdateGymBrandingMutationOptions(options));
};

/**
 * @summary Get AI assistant config (public)
 */
export const getGetGymAiAssistantPublicUrl = (id: string) => {
  return `/api/gyms/${id}/ai-assistant-public`;
};

export const getGymAiAssistantPublic = async (
  id: string,
  options?: RequestInit,
): Promise<AiAssistantConfig> => {
  return customFetch<AiAssistantConfig>(getGetGymAiAssistantPublicUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymAiAssistantPublicQueryKey = (id: string) => {
  return [`/api/gyms/${id}/ai-assistant-public`] as const;
};

export const getGetGymAiAssistantPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymAiAssistantPublic>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymAiAssistantPublic>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymAiAssistantPublicQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymAiAssistantPublic>>
  > = ({ signal }) =>
    getGymAiAssistantPublic(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymAiAssistantPublic>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymAiAssistantPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymAiAssistantPublic>>
>;
export type GetGymAiAssistantPublicQueryError = ErrorType<unknown>;

/**
 * @summary Get AI assistant config (public)
 */

export function useGetGymAiAssistantPublic<
  TData = Awaited<ReturnType<typeof getGymAiAssistantPublic>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymAiAssistantPublic>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymAiAssistantPublicQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get AI assistant config
 */
export const getGetGymAiAssistantUrl = (id: string) => {
  return `/api/gyms/${id}/ai-assistant`;
};

export const getGymAiAssistant = async (
  id: string,
  options?: RequestInit,
): Promise<AiAssistantConfig> => {
  return customFetch<AiAssistantConfig>(getGetGymAiAssistantUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymAiAssistantQueryKey = (id: string) => {
  return [`/api/gyms/${id}/ai-assistant`] as const;
};

export const getGetGymAiAssistantQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymAiAssistant>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymAiAssistant>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymAiAssistantQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymAiAssistant>>
  > = ({ signal }) => getGymAiAssistant(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymAiAssistant>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymAiAssistantQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymAiAssistant>>
>;
export type GetGymAiAssistantQueryError = ErrorType<unknown>;

/**
 * @summary Get AI assistant config
 */

export function useGetGymAiAssistant<
  TData = Awaited<ReturnType<typeof getGymAiAssistant>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymAiAssistant>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymAiAssistantQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update AI assistant config
 */
export const getUpdateGymAiAssistantUrl = (id: string) => {
  return `/api/gyms/${id}/ai-assistant`;
};

export const updateGymAiAssistant = async (
  id: string,
  aiAssistantConfig: AiAssistantConfig,
  options?: RequestInit,
): Promise<AiAssistantConfig> => {
  return customFetch<AiAssistantConfig>(getUpdateGymAiAssistantUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiAssistantConfig),
  });
};

export const getUpdateGymAiAssistantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymAiAssistant>>,
    TError,
    { id: string; data: BodyType<AiAssistantConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGymAiAssistant>>,
  TError,
  { id: string; data: BodyType<AiAssistantConfig> },
  TContext
> => {
  const mutationKey = ["updateGymAiAssistant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGymAiAssistant>>,
    { id: string; data: BodyType<AiAssistantConfig> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGymAiAssistant(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymAiAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGymAiAssistant>>
>;
export type UpdateGymAiAssistantMutationBody = BodyType<AiAssistantConfig>;
export type UpdateGymAiAssistantMutationError = ErrorType<unknown>;

/**
 * @summary Update AI assistant config
 */
export const useUpdateGymAiAssistant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymAiAssistant>>,
    TError,
    { id: string; data: BodyType<AiAssistantConfig> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGymAiAssistant>>,
  TError,
  { id: string; data: BodyType<AiAssistantConfig> },
  TContext
> => {
  return useMutation(getUpdateGymAiAssistantMutationOptions(options));
};

/**
 * @summary List gym locations
 */
export const getListLocationsUrl = (gymId: string) => {
  return `/api/locations/gym/${gymId}`;
};

export const listLocations = async (
  gymId: string,
  options?: RequestInit,
): Promise<Location[]> => {
  return customFetch<Location[]>(getListLocationsUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getListLocationsQueryKey = (gymId: string) => {
  return [`/api/locations/gym/${gymId}`] as const;
};

export const getListLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLocations>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLocationsQueryKey(gymId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocations>>> = ({
    signal,
  }) => listLocations(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLocations>>
>;
export type ListLocationsQueryError = ErrorType<unknown>;

/**
 * @summary List gym locations
 */

export function useListLocations<
  TData = Awaited<ReturnType<typeof listLocations>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLocationsQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a location
 */
export const getCreateLocationUrl = () => {
  return `/api/locations`;
};

export const createLocation = async (
  createLocationInput: CreateLocationInput,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getCreateLocationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLocationInput),
  });
};

export const getCreateLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocation>>,
    TError,
    { data: BodyType<CreateLocationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLocation>>,
  TError,
  { data: BodyType<CreateLocationInput> },
  TContext
> => {
  const mutationKey = ["createLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLocation>>,
    { data: BodyType<CreateLocationInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createLocation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLocation>>
>;
export type CreateLocationMutationBody = BodyType<CreateLocationInput>;
export type CreateLocationMutationError = ErrorType<unknown>;

/**
 * @summary Add a location
 */
export const useCreateLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocation>>,
    TError,
    { data: BodyType<CreateLocationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLocation>>,
  TError,
  { data: BodyType<CreateLocationInput> },
  TContext
> => {
  return useMutation(getCreateLocationMutationOptions(options));
};

/**
 * @summary Update location
 */
export const getUpdateLocationUrl = (id: string) => {
  return `/api/locations/${id}`;
};

export const updateLocation = async (
  id: string,
  updateLocationInput: UpdateLocationInput,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getUpdateLocationUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLocationInput),
  });
};

export const getUpdateLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocation>>,
    TError,
    { id: string; data: BodyType<UpdateLocationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLocation>>,
  TError,
  { id: string; data: BodyType<UpdateLocationInput> },
  TContext
> => {
  const mutationKey = ["updateLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLocation>>,
    { id: string; data: BodyType<UpdateLocationInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLocation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLocation>>
>;
export type UpdateLocationMutationBody = BodyType<UpdateLocationInput>;
export type UpdateLocationMutationError = ErrorType<unknown>;

/**
 * @summary Update location
 */
export const useUpdateLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocation>>,
    TError,
    { id: string; data: BodyType<UpdateLocationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLocation>>,
  TError,
  { id: string; data: BodyType<UpdateLocationInput> },
  TContext
> => {
  return useMutation(getUpdateLocationMutationOptions(options));
};

/**
 * @summary Toggle location active status
 */
export const getToggleLocationActiveUrl = (id: string) => {
  return `/api/locations/${id}/activate`;
};

export const toggleLocationActive = async (
  id: string,
  toggleLocationActiveBody: ToggleLocationActiveBody,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getToggleLocationActiveUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(toggleLocationActiveBody),
  });
};

export const getToggleLocationActiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleLocationActive>>,
    TError,
    { id: string; data: BodyType<ToggleLocationActiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleLocationActive>>,
  TError,
  { id: string; data: BodyType<ToggleLocationActiveBody> },
  TContext
> => {
  const mutationKey = ["toggleLocationActive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleLocationActive>>,
    { id: string; data: BodyType<ToggleLocationActiveBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return toggleLocationActive(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleLocationActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleLocationActive>>
>;
export type ToggleLocationActiveMutationBody =
  BodyType<ToggleLocationActiveBody>;
export type ToggleLocationActiveMutationError = ErrorType<unknown>;

/**
 * @summary Toggle location active status
 */
export const useToggleLocationActive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleLocationActive>>,
    TError,
    { id: string; data: BodyType<ToggleLocationActiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof toggleLocationActive>>,
  TError,
  { id: string; data: BodyType<ToggleLocationActiveBody> },
  TContext
> => {
  return useMutation(getToggleLocationActiveMutationOptions(options));
};

/**
 * @summary List availability blocks for a location
 */
export const getListLocationAvailabilityUrl = (locationId: string) => {
  return `/api/locations/${locationId}/availability`;
};

export const listLocationAvailability = async (
  locationId: string,
  options?: RequestInit,
): Promise<LocationAvailabilityBlock[]> => {
  return customFetch<LocationAvailabilityBlock[]>(
    getListLocationAvailabilityUrl(locationId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListLocationAvailabilityQueryKey = (locationId: string) => {
  return [`/api/locations/${locationId}/availability`] as const;
};

export const getListLocationAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof listLocationAvailability>>,
  TError = ErrorType<unknown>,
>(
  locationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocationAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLocationAvailabilityQueryKey(locationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLocationAvailability>>
  > = ({ signal }) =>
    listLocationAvailability(locationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!locationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLocationAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLocationAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLocationAvailability>>
>;
export type ListLocationAvailabilityQueryError = ErrorType<unknown>;

/**
 * @summary List availability blocks for a location
 */

export function useListLocationAvailability<
  TData = Awaited<ReturnType<typeof listLocationAvailability>>,
  TError = ErrorType<unknown>,
>(
  locationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocationAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLocationAvailabilityQueryOptions(
    locationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add availability block to a location
 */
export const getCreateLocationAvailabilityUrl = (locationId: string) => {
  return `/api/locations/${locationId}/availability`;
};

export const createLocationAvailability = async (
  locationId: string,
  createLocationAvailabilityInput: CreateLocationAvailabilityInput,
  options?: RequestInit,
): Promise<LocationAvailabilityBlock> => {
  return customFetch<LocationAvailabilityBlock>(
    getCreateLocationAvailabilityUrl(locationId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createLocationAvailabilityInput),
    },
  );
};

export const getCreateLocationAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocationAvailability>>,
    TError,
    { locationId: string; data: BodyType<CreateLocationAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLocationAvailability>>,
  TError,
  { locationId: string; data: BodyType<CreateLocationAvailabilityInput> },
  TContext
> => {
  const mutationKey = ["createLocationAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLocationAvailability>>,
    { locationId: string; data: BodyType<CreateLocationAvailabilityInput> }
  > = (props) => {
    const { locationId, data } = props ?? {};

    return createLocationAvailability(locationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLocationAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLocationAvailability>>
>;
export type CreateLocationAvailabilityMutationBody =
  BodyType<CreateLocationAvailabilityInput>;
export type CreateLocationAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Add availability block to a location
 */
export const useCreateLocationAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocationAvailability>>,
    TError,
    { locationId: string; data: BodyType<CreateLocationAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLocationAvailability>>,
  TError,
  { locationId: string; data: BodyType<CreateLocationAvailabilityInput> },
  TContext
> => {
  return useMutation(getCreateLocationAvailabilityMutationOptions(options));
};

/**
 * @summary Update a location availability block
 */
export const getUpdateLocationAvailabilityUrl = (
  locationId: string,
  id: string,
) => {
  return `/api/locations/${locationId}/availability/${id}`;
};

export const updateLocationAvailability = async (
  locationId: string,
  id: string,
  updateLocationAvailabilityInput: UpdateLocationAvailabilityInput,
  options?: RequestInit,
): Promise<LocationAvailabilityBlock> => {
  return customFetch<LocationAvailabilityBlock>(
    getUpdateLocationAvailabilityUrl(locationId, id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateLocationAvailabilityInput),
    },
  );
};

export const getUpdateLocationAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocationAvailability>>,
    TError,
    {
      locationId: string;
      id: string;
      data: BodyType<UpdateLocationAvailabilityInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLocationAvailability>>,
  TError,
  {
    locationId: string;
    id: string;
    data: BodyType<UpdateLocationAvailabilityInput>;
  },
  TContext
> => {
  const mutationKey = ["updateLocationAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLocationAvailability>>,
    {
      locationId: string;
      id: string;
      data: BodyType<UpdateLocationAvailabilityInput>;
    }
  > = (props) => {
    const { locationId, id, data } = props ?? {};

    return updateLocationAvailability(locationId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLocationAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLocationAvailability>>
>;
export type UpdateLocationAvailabilityMutationBody =
  BodyType<UpdateLocationAvailabilityInput>;
export type UpdateLocationAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Update a location availability block
 */
export const useUpdateLocationAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocationAvailability>>,
    TError,
    {
      locationId: string;
      id: string;
      data: BodyType<UpdateLocationAvailabilityInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLocationAvailability>>,
  TError,
  {
    locationId: string;
    id: string;
    data: BodyType<UpdateLocationAvailabilityInput>;
  },
  TContext
> => {
  return useMutation(getUpdateLocationAvailabilityMutationOptions(options));
};

/**
 * @summary Delete a location availability block
 */
export const getDeleteLocationAvailabilityUrl = (
  locationId: string,
  id: string,
) => {
  return `/api/locations/${locationId}/availability/${id}`;
};

export const deleteLocationAvailability = async (
  locationId: string,
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLocationAvailabilityUrl(locationId, id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLocationAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocationAvailability>>,
    TError,
    { locationId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLocationAvailability>>,
  TError,
  { locationId: string; id: string },
  TContext
> => {
  const mutationKey = ["deleteLocationAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLocationAvailability>>,
    { locationId: string; id: string }
  > = (props) => {
    const { locationId, id } = props ?? {};

    return deleteLocationAvailability(locationId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLocationAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLocationAvailability>>
>;

export type DeleteLocationAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Delete a location availability block
 */
export const useDeleteLocationAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocationAvailability>>,
    TError,
    { locationId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLocationAvailability>>,
  TError,
  { locationId: string; id: string },
  TContext
> => {
  return useMutation(getDeleteLocationAvailabilityMutationOptions(options));
};

/**
 * @summary Copy schedule from source location to all synced locations
 */
export const getCopyLocationScheduleUrl = (locationId: string) => {
  return `/api/locations/${locationId}/copy-schedule`;
};

export const copyLocationSchedule = async (
  locationId: string,
  options?: RequestInit,
): Promise<CopyLocationSchedule200> => {
  return customFetch<CopyLocationSchedule200>(
    getCopyLocationScheduleUrl(locationId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCopyLocationScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyLocationSchedule>>,
    TError,
    { locationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyLocationSchedule>>,
  TError,
  { locationId: string },
  TContext
> => {
  const mutationKey = ["copyLocationSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyLocationSchedule>>,
    { locationId: string }
  > = (props) => {
    const { locationId } = props ?? {};

    return copyLocationSchedule(locationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyLocationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyLocationSchedule>>
>;

export type CopyLocationScheduleMutationError = ErrorType<unknown>;

/**
 * @summary Copy schedule from source location to all synced locations
 */
export const useCopyLocationSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyLocationSchedule>>,
    TError,
    { locationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof copyLocationSchedule>>,
  TError,
  { locationId: string },
  TContext
> => {
  return useMutation(getCopyLocationScheduleMutationOptions(options));
};

/**
 * @summary Get schedule sync settings for a gym
 */
export const getGetGymScheduleSyncUrl = (id: string) => {
  return `/api/gyms/${id}/schedule-sync`;
};

export const getGymScheduleSync = async (
  id: string,
  options?: RequestInit,
): Promise<GetGymScheduleSync200> => {
  return customFetch<GetGymScheduleSync200>(getGetGymScheduleSyncUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGymScheduleSyncQueryKey = (id: string) => {
  return [`/api/gyms/${id}/schedule-sync`] as const;
};

export const getGetGymScheduleSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymScheduleSync>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymScheduleSync>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymScheduleSyncQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymScheduleSync>>
  > = ({ signal }) => getGymScheduleSync(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymScheduleSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymScheduleSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymScheduleSync>>
>;
export type GetGymScheduleSyncQueryError = ErrorType<unknown>;

/**
 * @summary Get schedule sync settings for a gym
 */

export function useGetGymScheduleSync<
  TData = Awaited<ReturnType<typeof getGymScheduleSync>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymScheduleSync>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymScheduleSyncQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Toggle schedule sync for a gym
 */
export const getUpdateGymScheduleSyncUrl = (id: string) => {
  return `/api/gyms/${id}/schedule-sync`;
};

export const updateGymScheduleSync = async (
  id: string,
  updateGymScheduleSyncBody: UpdateGymScheduleSyncBody,
  options?: RequestInit,
): Promise<UpdateGymScheduleSync200> => {
  return customFetch<UpdateGymScheduleSync200>(
    getUpdateGymScheduleSyncUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateGymScheduleSyncBody),
    },
  );
};

export const getUpdateGymScheduleSyncMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymScheduleSync>>,
    TError,
    { id: string; data: BodyType<UpdateGymScheduleSyncBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGymScheduleSync>>,
  TError,
  { id: string; data: BodyType<UpdateGymScheduleSyncBody> },
  TContext
> => {
  const mutationKey = ["updateGymScheduleSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGymScheduleSync>>,
    { id: string; data: BodyType<UpdateGymScheduleSyncBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGymScheduleSync(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGymScheduleSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGymScheduleSync>>
>;
export type UpdateGymScheduleSyncMutationBody =
  BodyType<UpdateGymScheduleSyncBody>;
export type UpdateGymScheduleSyncMutationError = ErrorType<unknown>;

/**
 * @summary Toggle schedule sync for a gym
 */
export const useUpdateGymScheduleSync = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGymScheduleSync>>,
    TError,
    { id: string; data: BodyType<UpdateGymScheduleSyncBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGymScheduleSync>>,
  TError,
  { id: string; data: BodyType<UpdateGymScheduleSyncBody> },
  TContext
> => {
  return useMutation(getUpdateGymScheduleSyncMutationOptions(options));
};

/**
 * @summary List trainers across all gyms
 */
export const getListPublicTrainersUrl = (params?: ListPublicTrainersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trainers/public?${stringifiedParams}`
    : `/api/trainers/public`;
};

export const listPublicTrainers = async (
  params?: ListPublicTrainersParams,
  options?: RequestInit,
): Promise<PublicTrainer[]> => {
  return customFetch<PublicTrainer[]>(getListPublicTrainersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPublicTrainersQueryKey = (
  params?: ListPublicTrainersParams,
) => {
  return [`/api/trainers/public`, ...(params ? [params] : [])] as const;
};

export const getListPublicTrainersQueryOptions = <
  TData = Awaited<ReturnType<typeof listPublicTrainers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPublicTrainersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPublicTrainers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPublicTrainersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPublicTrainers>>
  > = ({ signal }) => listPublicTrainers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPublicTrainers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPublicTrainersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPublicTrainers>>
>;
export type ListPublicTrainersQueryError = ErrorType<unknown>;

/**
 * @summary List trainers across all gyms
 */

export function useListPublicTrainers<
  TData = Awaited<ReturnType<typeof listPublicTrainers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPublicTrainersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPublicTrainers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPublicTrainersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get public trainer profile by slug
 */
export const getGetTrainerBySlugUrl = (slug: string) => {
  return `/api/trainers/slug/${slug}`;
};

export const getTrainerBySlug = async (
  slug: string,
  options?: RequestInit,
): Promise<TrainerPublicProfile> => {
  return customFetch<TrainerPublicProfile>(getGetTrainerBySlugUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerBySlugQueryKey = (slug: string) => {
  return [`/api/trainers/slug/${slug}`] as const;
};

export const getGetTrainerBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerBySlug>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerBySlug>>
  > = ({ signal }) => getTrainerBySlug(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerBySlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerBySlug>>
>;
export type GetTrainerBySlugQueryError = ErrorType<void>;

/**
 * @summary Get public trainer profile by slug
 */

export function useGetTrainerBySlug<
  TData = Awaited<ReturnType<typeof getTrainerBySlug>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List trainers for a gym
 */
export const getListTrainersUrl = (
  gymId: string,
  params?: ListTrainersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trainers/gym/${gymId}?${stringifiedParams}`
    : `/api/trainers/gym/${gymId}`;
};

export const listTrainers = async (
  gymId: string,
  params?: ListTrainersParams,
  options?: RequestInit,
): Promise<TrainerProfile[]> => {
  return customFetch<TrainerProfile[]>(getListTrainersUrl(gymId, params), {
    ...options,
    method: "GET",
  });
};

export const getListTrainersQueryKey = (
  gymId: string,
  params?: ListTrainersParams,
) => {
  return [`/api/trainers/gym/${gymId}`, ...(params ? [params] : [])] as const;
};

export const getListTrainersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrainers>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: ListTrainersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrainers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTrainersQueryKey(gymId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainers>>> = ({
    signal,
  }) => listTrainers(gymId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrainers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrainersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrainers>>
>;
export type ListTrainersQueryError = ErrorType<unknown>;

/**
 * @summary List trainers for a gym
 */

export function useListTrainers<
  TData = Awaited<ReturnType<typeof listTrainers>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: ListTrainersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrainers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrainersQueryOptions(gymId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get trainer profile
 */
export const getGetTrainerUrl = (id: string) => {
  return `/api/trainers/${id}`;
};

export const getTrainer = async (
  id: string,
  options?: RequestInit,
): Promise<TrainerProfile> => {
  return customFetch<TrainerProfile>(getGetTrainerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerQueryKey = (id: string) => {
  return [`/api/trainers/${id}`] as const;
};

export const getGetTrainerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainer>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainer>>> = ({
    signal,
  }) => getTrainer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainer>>
>;
export type GetTrainerQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer profile
 */

export function useGetTrainer<
  TData = Awaited<ReturnType<typeof getTrainer>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Remove a trainer from the gym (admin)
 */
export const getDeleteTrainerUrl = (id: string) => {
  return `/api/trainers/${id}`;
};

export const deleteTrainer = async (
  id: string,
  options?: RequestInit,
): Promise<DeleteTrainer200> => {
  return customFetch<DeleteTrainer200>(getDeleteTrainerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrainerMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrainer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTrainer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrainer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrainer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrainerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrainer>>
>;

export type DeleteTrainerMutationError = ErrorType<void>;

/**
 * @summary Remove a trainer from the gym (admin)
 */
export const useDeleteTrainer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrainer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTrainerMutationOptions(options));
};

/**
 * @summary Create trainer (admin)
 */
export const getCreateTrainerUrl = () => {
  return `/api/trainers`;
};

export const createTrainer = async (
  createTrainerInput: CreateTrainerInput,
  options?: RequestInit,
): Promise<TrainerProfile> => {
  return customFetch<TrainerProfile>(getCreateTrainerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTrainerInput),
  });
};

export const getCreateTrainerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainer>>,
    TError,
    { data: BodyType<CreateTrainerInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrainer>>,
  TError,
  { data: BodyType<CreateTrainerInput> },
  TContext
> => {
  const mutationKey = ["createTrainer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrainer>>,
    { data: BodyType<CreateTrainerInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrainer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrainerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrainer>>
>;
export type CreateTrainerMutationBody = BodyType<CreateTrainerInput>;
export type CreateTrainerMutationError = ErrorType<unknown>;

/**
 * @summary Create trainer (admin)
 */
export const useCreateTrainer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainer>>,
    TError,
    { data: BodyType<CreateTrainerInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrainer>>,
  TError,
  { data: BodyType<CreateTrainerInput> },
  TContext
> => {
  return useMutation(getCreateTrainerMutationOptions(options));
};

/**
 * @summary Update trainer settings (admin)
 */
export const getUpdateTrainerAdminSettingsUrl = (id: string) => {
  return `/api/trainers/${id}/admin-settings`;
};

export const updateTrainerAdminSettings = async (
  id: string,
  updateTrainerAdminInput: UpdateTrainerAdminInput,
  options?: RequestInit,
): Promise<TrainerProfile> => {
  return customFetch<TrainerProfile>(getUpdateTrainerAdminSettingsUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrainerAdminInput),
  });
};

export const getUpdateTrainerAdminSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerAdminSettings>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerAdminInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainerAdminSettings>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerAdminInput> },
  TContext
> => {
  const mutationKey = ["updateTrainerAdminSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainerAdminSettings>>,
    { id: string; data: BodyType<UpdateTrainerAdminInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainerAdminSettings(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainerAdminSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainerAdminSettings>>
>;
export type UpdateTrainerAdminSettingsMutationBody =
  BodyType<UpdateTrainerAdminInput>;
export type UpdateTrainerAdminSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update trainer settings (admin)
 */
export const useUpdateTrainerAdminSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerAdminSettings>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerAdminInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainerAdminSettings>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerAdminInput> },
  TContext
> => {
  return useMutation(getUpdateTrainerAdminSettingsMutationOptions(options));
};

/**
 * @summary Get trainer location assignments
 */
export const getGetTrainerLocationsUrl = (id: string) => {
  return `/api/trainers/${id}/locations`;
};

export const getTrainerLocations = async (
  id: string,
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getGetTrainerLocationsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerLocationsQueryKey = (id: string) => {
  return [`/api/trainers/${id}/locations`] as const;
};

export const getGetTrainerLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerLocations>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerLocationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerLocations>>
  > = ({ signal }) => getTrainerLocations(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerLocations>>
>;
export type GetTrainerLocationsQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer location assignments
 */

export function useGetTrainerLocations<
  TData = Awaited<ReturnType<typeof getTrainerLocations>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerLocationsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update trainer location assignments
 */
export const getUpdateTrainerLocationsUrl = (id: string) => {
  return `/api/trainers/${id}/locations`;
};

export const updateTrainerLocations = async (
  id: string,
  updateTrainerLocationsBody: UpdateTrainerLocationsBody,
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getUpdateTrainerLocationsUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrainerLocationsBody),
  });
};

export const getUpdateTrainerLocationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerLocations>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainerLocations>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerLocationsBody> },
  TContext
> => {
  const mutationKey = ["updateTrainerLocations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainerLocations>>,
    { id: string; data: BodyType<UpdateTrainerLocationsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainerLocations(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainerLocationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainerLocations>>
>;
export type UpdateTrainerLocationsMutationBody =
  BodyType<UpdateTrainerLocationsBody>;
export type UpdateTrainerLocationsMutationError = ErrorType<unknown>;

/**
 * @summary Update trainer location assignments
 */
export const useUpdateTrainerLocations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerLocations>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainerLocations>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerLocationsBody> },
  TContext
> => {
  return useMutation(getUpdateTrainerLocationsMutationOptions(options));
};

/**
 * @summary Get students that have had sessions with this trainer
 */
export const getGetTrainerStudentsUrl = (id: string) => {
  return `/api/trainers/${id}/students`;
};

export const getTrainerStudents = async (
  id: string,
  options?: RequestInit,
): Promise<GetTrainerStudents200Item[]> => {
  return customFetch<GetTrainerStudents200Item[]>(
    getGetTrainerStudentsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainerStudentsQueryKey = (id: string) => {
  return [`/api/trainers/${id}/students`] as const;
};

export const getGetTrainerStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerStudents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerStudents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerStudentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerStudents>>
  > = ({ signal }) => getTrainerStudents(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerStudents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerStudents>>
>;
export type GetTrainerStudentsQueryError = ErrorType<unknown>;

/**
 * @summary Get students that have had sessions with this trainer
 */

export function useGetTrainerStudents<
  TData = Awaited<ReturnType<typeof getTrainerStudents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerStudents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerStudentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List per-client rate overrides for a trainer
 */
export const getGetTrainerClientRatesUrl = (id: string) => {
  return `/api/trainers/${id}/client-rates`;
};

export const getTrainerClientRates = async (
  id: string,
  options?: RequestInit,
): Promise<TrainerClientRate[]> => {
  return customFetch<TrainerClientRate[]>(getGetTrainerClientRatesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerClientRatesQueryKey = (id: string) => {
  return [`/api/trainers/${id}/client-rates`] as const;
};

export const getGetTrainerClientRatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerClientRates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerClientRates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrainerClientRatesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerClientRates>>
  > = ({ signal }) => getTrainerClientRates(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerClientRates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerClientRatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerClientRates>>
>;
export type GetTrainerClientRatesQueryError = ErrorType<unknown>;

/**
 * @summary List per-client rate overrides for a trainer
 */

export function useGetTrainerClientRates<
  TData = Awaited<ReturnType<typeof getTrainerClientRates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerClientRates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerClientRatesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update a per-client rate override
 */
export const getCreateTrainerClientRateUrl = (id: string) => {
  return `/api/trainers/${id}/client-rates`;
};

export const createTrainerClientRate = async (
  id: string,
  createTrainerClientRateBody: CreateTrainerClientRateBody,
  options?: RequestInit,
): Promise<TrainerClientRate> => {
  return customFetch<TrainerClientRate>(getCreateTrainerClientRateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTrainerClientRateBody),
  });
};

export const getCreateTrainerClientRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainerClientRate>>,
    TError,
    { id: string; data: BodyType<CreateTrainerClientRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrainerClientRate>>,
  TError,
  { id: string; data: BodyType<CreateTrainerClientRateBody> },
  TContext
> => {
  const mutationKey = ["createTrainerClientRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrainerClientRate>>,
    { id: string; data: BodyType<CreateTrainerClientRateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTrainerClientRate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrainerClientRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrainerClientRate>>
>;
export type CreateTrainerClientRateMutationBody =
  BodyType<CreateTrainerClientRateBody>;
export type CreateTrainerClientRateMutationError = ErrorType<unknown>;

/**
 * @summary Create or update a per-client rate override
 */
export const useCreateTrainerClientRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainerClientRate>>,
    TError,
    { id: string; data: BodyType<CreateTrainerClientRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrainerClientRate>>,
  TError,
  { id: string; data: BodyType<CreateTrainerClientRateBody> },
  TContext
> => {
  return useMutation(getCreateTrainerClientRateMutationOptions(options));
};

/**
 * @summary Delete a per-client rate override
 */
export const getDeleteTrainerClientRateUrl = (id: string, rateId: string) => {
  return `/api/trainers/${id}/client-rates/${rateId}`;
};

export const deleteTrainerClientRate = async (
  id: string,
  rateId: string,
  options?: RequestInit,
): Promise<DeleteTrainerClientRate200> => {
  return customFetch<DeleteTrainerClientRate200>(
    getDeleteTrainerClientRateUrl(id, rateId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTrainerClientRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainerClientRate>>,
    TError,
    { id: string; rateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrainerClientRate>>,
  TError,
  { id: string; rateId: string },
  TContext
> => {
  const mutationKey = ["deleteTrainerClientRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrainerClientRate>>,
    { id: string; rateId: string }
  > = (props) => {
    const { id, rateId } = props ?? {};

    return deleteTrainerClientRate(id, rateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrainerClientRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrainerClientRate>>
>;

export type DeleteTrainerClientRateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a per-client rate override
 */
export const useDeleteTrainerClientRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainerClientRate>>,
    TError,
    { id: string; rateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrainerClientRate>>,
  TError,
  { id: string; rateId: string },
  TContext
> => {
  return useMutation(getDeleteTrainerClientRateMutationOptions(options));
};

/**
 * @summary Trainer self-set rate
 */
export const getUpdateTrainerRateUrl = (id: string) => {
  return `/api/trainers/${id}/rate`;
};

export const updateTrainerRate = async (
  id: string,
  updateTrainerRateBody: UpdateTrainerRateBody,
  options?: RequestInit,
): Promise<TrainerProfile> => {
  return customFetch<TrainerProfile>(getUpdateTrainerRateUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrainerRateBody),
  });
};

export const getUpdateTrainerRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerRate>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainerRate>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerRateBody> },
  TContext
> => {
  const mutationKey = ["updateTrainerRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainerRate>>,
    { id: string; data: BodyType<UpdateTrainerRateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainerRate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainerRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainerRate>>
>;
export type UpdateTrainerRateMutationBody = BodyType<UpdateTrainerRateBody>;
export type UpdateTrainerRateMutationError = ErrorType<unknown>;

/**
 * @summary Trainer self-set rate
 */
export const useUpdateTrainerRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerRate>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainerRate>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerRateBody> },
  TContext
> => {
  return useMutation(getUpdateTrainerRateMutationOptions(options));
};

/**
 * @summary Update trainer profile
 */
export const getUpdateTrainerProfileUrl = (id: string) => {
  return `/api/trainers/${id}/profile`;
};

export const updateTrainerProfile = async (
  id: string,
  updateTrainerProfileInput: UpdateTrainerProfileInput,
  options?: RequestInit,
): Promise<TrainerProfile> => {
  return customFetch<TrainerProfile>(getUpdateTrainerProfileUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrainerProfileInput),
  });
};

export const getUpdateTrainerProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerProfile>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerProfileInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainerProfile>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerProfileInput> },
  TContext
> => {
  const mutationKey = ["updateTrainerProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainerProfile>>,
    { id: string; data: BodyType<UpdateTrainerProfileInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainerProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainerProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainerProfile>>
>;
export type UpdateTrainerProfileMutationBody =
  BodyType<UpdateTrainerProfileInput>;
export type UpdateTrainerProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update trainer profile
 */
export const useUpdateTrainerProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerProfile>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerProfileInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainerProfile>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerProfileInput> },
  TContext
> => {
  return useMutation(getUpdateTrainerProfileMutationOptions(options));
};

/**
 * @summary Search trainers with scheduling assistant filters
 */
export const getSearchTrainersAssistantUrl = () => {
  return `/api/trainers/search-assistant`;
};

export const searchTrainersAssistant = async (
  searchAssistantInput: SearchAssistantInput,
  options?: RequestInit,
): Promise<SearchAssistantResponse> => {
  return customFetch<SearchAssistantResponse>(getSearchTrainersAssistantUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(searchAssistantInput),
  });
};

export const getSearchTrainersAssistantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchTrainersAssistant>>,
    TError,
    { data: BodyType<SearchAssistantInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchTrainersAssistant>>,
  TError,
  { data: BodyType<SearchAssistantInput> },
  TContext
> => {
  const mutationKey = ["searchTrainersAssistant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchTrainersAssistant>>,
    { data: BodyType<SearchAssistantInput> }
  > = (props) => {
    const { data } = props ?? {};

    return searchTrainersAssistant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchTrainersAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchTrainersAssistant>>
>;
export type SearchTrainersAssistantMutationBody =
  BodyType<SearchAssistantInput>;
export type SearchTrainersAssistantMutationError = ErrorType<unknown>;

/**
 * @summary Search trainers with scheduling assistant filters
 */
export const useSearchTrainersAssistant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchTrainersAssistant>>,
    TError,
    { data: BodyType<SearchAssistantInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchTrainersAssistant>>,
  TError,
  { data: BodyType<SearchAssistantInput> },
  TContext
> => {
  return useMutation(getSearchTrainersAssistantMutationOptions(options));
};

/**
 * @summary Invite a trainer (admin)
 */
export const getInviteTrainerUrl = () => {
  return `/api/trainers/invite`;
};

export const inviteTrainer = async (
  inviteTrainerInput: InviteTrainerInput,
  options?: RequestInit,
): Promise<TrainerInvite> => {
  return customFetch<TrainerInvite>(getInviteTrainerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteTrainerInput),
  });
};

export const getInviteTrainerMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteTrainer>>,
    TError,
    { data: BodyType<InviteTrainerInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteTrainer>>,
  TError,
  { data: BodyType<InviteTrainerInput> },
  TContext
> => {
  const mutationKey = ["inviteTrainer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteTrainer>>,
    { data: BodyType<InviteTrainerInput> }
  > = (props) => {
    const { data } = props ?? {};

    return inviteTrainer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteTrainerMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteTrainer>>
>;
export type InviteTrainerMutationBody = BodyType<InviteTrainerInput>;
export type InviteTrainerMutationError = ErrorType<void>;

/**
 * @summary Invite a trainer (admin)
 */
export const useInviteTrainer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteTrainer>>,
    TError,
    { data: BodyType<InviteTrainerInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteTrainer>>,
  TError,
  { data: BodyType<InviteTrainerInput> },
  TContext
> => {
  return useMutation(getInviteTrainerMutationOptions(options));
};

/**
 * @summary List trainer invites for gym (admin)
 */
export const getListTrainerInvitesUrl = () => {
  return `/api/trainers/invites`;
};

export const listTrainerInvites = async (
  options?: RequestInit,
): Promise<TrainerInvite[]> => {
  return customFetch<TrainerInvite[]>(getListTrainerInvitesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTrainerInvitesQueryKey = () => {
  return [`/api/trainers/invites`] as const;
};

export const getListTrainerInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrainerInvites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrainerInvites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTrainerInvitesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrainerInvites>>
  > = ({ signal }) => listTrainerInvites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrainerInvites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrainerInvitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrainerInvites>>
>;
export type ListTrainerInvitesQueryError = ErrorType<unknown>;

/**
 * @summary List trainer invites for gym (admin)
 */

export function useListTrainerInvites<
  TData = Awaited<ReturnType<typeof listTrainerInvites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrainerInvites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrainerInvitesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get trainer invite details (public)
 */
export const getGetTrainerInviteUrl = (token: string) => {
  return `/api/trainers/invite/${token}`;
};

export const getTrainerInvite = async (
  token: string,
  options?: RequestInit,
): Promise<TrainerInviteDetails> => {
  return customFetch<TrainerInviteDetails>(getGetTrainerInviteUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerInviteQueryKey = (token: string) => {
  return [`/api/trainers/invite/${token}`] as const;
};

export const getGetTrainerInviteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerInvite>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerInvite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerInviteQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerInvite>>
  > = ({ signal }) => getTrainerInvite(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerInvite>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerInviteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerInvite>>
>;
export type GetTrainerInviteQueryError = ErrorType<void>;

/**
 * @summary Get trainer invite details (public)
 */

export function useGetTrainerInvite<
  TData = Awaited<ReturnType<typeof getTrainerInvite>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerInvite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerInviteQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cancel a pending trainer invite (admin)
 */
export const getCancelTrainerInviteUrl = (token: string) => {
  return `/api/trainers/invite/${token}`;
};

export const cancelTrainerInvite = async (
  token: string,
  options?: RequestInit,
): Promise<CancelTrainerInvite200> => {
  return customFetch<CancelTrainerInvite200>(getCancelTrainerInviteUrl(token), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelTrainerInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTrainerInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelTrainerInvite>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["cancelTrainerInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTrainerInvite>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return cancelTrainerInvite(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTrainerInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelTrainerInvite>>
>;

export type CancelTrainerInviteMutationError = ErrorType<void>;

/**
 * @summary Cancel a pending trainer invite (admin)
 */
export const useCancelTrainerInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTrainerInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelTrainerInvite>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getCancelTrainerInviteMutationOptions(options));
};

/**
 * @summary Accept trainer invite and create account
 */
export const getAcceptTrainerInviteUrl = (token: string) => {
  return `/api/trainers/invite/${token}/accept`;
};

export const acceptTrainerInvite = async (
  token: string,
  acceptTrainerInviteInput: AcceptTrainerInviteInput,
  options?: RequestInit,
): Promise<AcceptTrainerInviteResponse> => {
  return customFetch<AcceptTrainerInviteResponse>(
    getAcceptTrainerInviteUrl(token),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(acceptTrainerInviteInput),
    },
  );
};

export const getAcceptTrainerInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTrainerInvite>>,
    TError,
    { token: string; data: BodyType<AcceptTrainerInviteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTrainerInvite>>,
  TError,
  { token: string; data: BodyType<AcceptTrainerInviteInput> },
  TContext
> => {
  const mutationKey = ["acceptTrainerInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTrainerInvite>>,
    { token: string; data: BodyType<AcceptTrainerInviteInput> }
  > = (props) => {
    const { token, data } = props ?? {};

    return acceptTrainerInvite(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTrainerInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTrainerInvite>>
>;
export type AcceptTrainerInviteMutationBody =
  BodyType<AcceptTrainerInviteInput>;
export type AcceptTrainerInviteMutationError = ErrorType<void>;

/**
 * @summary Accept trainer invite and create account
 */
export const useAcceptTrainerInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTrainerInvite>>,
    TError,
    { token: string; data: BodyType<AcceptTrainerInviteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptTrainerInvite>>,
  TError,
  { token: string; data: BodyType<AcceptTrainerInviteInput> },
  TContext
> => {
  return useMutation(getAcceptTrainerInviteMutationOptions(options));
};

/**
 * @summary Resend a trainer invite (admin)
 */
export const getResendTrainerInviteUrl = (token: string) => {
  return `/api/trainers/invite/${token}/resend`;
};

export const resendTrainerInvite = async (
  token: string,
  options?: RequestInit,
): Promise<TrainerInvite> => {
  return customFetch<TrainerInvite>(getResendTrainerInviteUrl(token), {
    ...options,
    method: "POST",
  });
};

export const getResendTrainerInviteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendTrainerInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendTrainerInvite>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["resendTrainerInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendTrainerInvite>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return resendTrainerInvite(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendTrainerInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendTrainerInvite>>
>;

export type ResendTrainerInviteMutationError = ErrorType<unknown>;

/**
 * @summary Resend a trainer invite (admin)
 */
export const useResendTrainerInvite = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendTrainerInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendTrainerInvite>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getResendTrainerInviteMutationOptions(options));
};

/**
 * @summary Generate new Stripe Connect onboarding link
 */
export const getRefreshStripeConnectUrl = () => {
  return `/api/trainers/stripe-connect/refresh`;
};

export const refreshStripeConnect = async (
  options?: RequestInit,
): Promise<RefreshStripeConnect200> => {
  return customFetch<RefreshStripeConnect200>(getRefreshStripeConnectUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshStripeConnectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshStripeConnect>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshStripeConnect>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshStripeConnect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshStripeConnect>>,
    void
  > = () => {
    return refreshStripeConnect(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshStripeConnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshStripeConnect>>
>;

export type RefreshStripeConnectMutationError = ErrorType<unknown>;

/**
 * @summary Generate new Stripe Connect onboarding link
 */
export const useRefreshStripeConnect = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshStripeConnect>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshStripeConnect>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshStripeConnectMutationOptions(options));
};

/**
 * @summary Check and mark Stripe Connect onboarding complete
 */
export const getCompleteStripeConnectUrl = () => {
  return `/api/trainers/stripe-connect/complete`;
};

export const completeStripeConnect = async (
  options?: RequestInit,
): Promise<CompleteStripeConnect200> => {
  return customFetch<CompleteStripeConnect200>(getCompleteStripeConnectUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCompleteStripeConnectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeStripeConnect>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeStripeConnect>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["completeStripeConnect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeStripeConnect>>,
    void
  > = () => {
    return completeStripeConnect(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteStripeConnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeStripeConnect>>
>;

export type CompleteStripeConnectMutationError = ErrorType<unknown>;

/**
 * @summary Check and mark Stripe Connect onboarding complete
 */
export const useCompleteStripeConnect = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeStripeConnect>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeStripeConnect>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCompleteStripeConnectMutationOptions(options));
};

/**
 * @summary Get trainer weekly availability
 */
export const getGetTrainerAvailabilityUrl = (
  trainerId: string,
  params?: GetTrainerAvailabilityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/availability/trainer/${trainerId}?${stringifiedParams}`
    : `/api/availability/trainer/${trainerId}`;
};

export const getTrainerAvailability = async (
  trainerId: string,
  params?: GetTrainerAvailabilityParams,
  options?: RequestInit,
): Promise<AvailabilityBlock[]> => {
  return customFetch<AvailabilityBlock[]>(
    getGetTrainerAvailabilityUrl(trainerId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainerAvailabilityQueryKey = (
  trainerId: string,
  params?: GetTrainerAvailabilityParams,
) => {
  return [
    `/api/availability/trainer/${trainerId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTrainerAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerAvailability>>,
  TError = ErrorType<unknown>,
>(
  trainerId: string,
  params?: GetTrainerAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTrainerAvailabilityQueryKey(trainerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerAvailability>>
  > = ({ signal }) =>
    getTrainerAvailability(trainerId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!trainerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerAvailability>>
>;
export type GetTrainerAvailabilityQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer weekly availability
 */

export function useGetTrainerAvailability<
  TData = Awaited<ReturnType<typeof getTrainerAvailability>>,
  TError = ErrorType<unknown>,
>(
  trainerId: string,
  params?: GetTrainerAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrainerAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerAvailabilityQueryOptions(
    trainerId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add availability block
 */
export const getCreateAvailabilityUrl = () => {
  return `/api/availability`;
};

export const createAvailability = async (
  createAvailabilityInput: CreateAvailabilityInput,
  options?: RequestInit,
): Promise<AvailabilityBlock> => {
  return customFetch<AvailabilityBlock>(getCreateAvailabilityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAvailabilityInput),
  });
};

export const getCreateAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAvailability>>,
    TError,
    { data: BodyType<CreateAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAvailability>>,
  TError,
  { data: BodyType<CreateAvailabilityInput> },
  TContext
> => {
  const mutationKey = ["createAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAvailability>>,
    { data: BodyType<CreateAvailabilityInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createAvailability(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAvailability>>
>;
export type CreateAvailabilityMutationBody = BodyType<CreateAvailabilityInput>;
export type CreateAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Add availability block
 */
export const useCreateAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAvailability>>,
    TError,
    { data: BodyType<CreateAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAvailability>>,
  TError,
  { data: BodyType<CreateAvailabilityInput> },
  TContext
> => {
  return useMutation(getCreateAvailabilityMutationOptions(options));
};

/**
 * @summary Update availability block
 */
export const getUpdateAvailabilityUrl = (id: string) => {
  return `/api/availability/${id}`;
};

export const updateAvailability = async (
  id: string,
  updateAvailabilityInput: UpdateAvailabilityInput,
  options?: RequestInit,
): Promise<AvailabilityBlock> => {
  return customFetch<AvailabilityBlock>(getUpdateAvailabilityUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAvailabilityInput),
  });
};

export const getUpdateAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAvailability>>,
    TError,
    { id: string; data: BodyType<UpdateAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAvailability>>,
  TError,
  { id: string; data: BodyType<UpdateAvailabilityInput> },
  TContext
> => {
  const mutationKey = ["updateAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAvailability>>,
    { id: string; data: BodyType<UpdateAvailabilityInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAvailability(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAvailability>>
>;
export type UpdateAvailabilityMutationBody = BodyType<UpdateAvailabilityInput>;
export type UpdateAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Update availability block
 */
export const useUpdateAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAvailability>>,
    TError,
    { id: string; data: BodyType<UpdateAvailabilityInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAvailability>>,
  TError,
  { id: string; data: BodyType<UpdateAvailabilityInput> },
  TContext
> => {
  return useMutation(getUpdateAvailabilityMutationOptions(options));
};

/**
 * @summary Delete availability block
 */
export const getDeleteAvailabilityUrl = (id: string) => {
  return `/api/availability/${id}`;
};

export const deleteAvailability = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAvailabilityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAvailability>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAvailability>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAvailability>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAvailability(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAvailability>>
>;

export type DeleteAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Delete availability block
 */
export const useDeleteAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAvailability>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAvailability>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteAvailabilityMutationOptions(options));
};

/**
 * @summary Set availability across multiple locations
 */
export const getBulkSetAvailabilityUrl = () => {
  return `/api/availability/bulk`;
};

export const bulkSetAvailability = async (
  bulkSetAvailabilityBody: BulkSetAvailabilityBody,
  options?: RequestInit,
): Promise<AvailabilityBlock[]> => {
  return customFetch<AvailabilityBlock[]>(getBulkSetAvailabilityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkSetAvailabilityBody),
  });
};

export const getBulkSetAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkSetAvailability>>,
    TError,
    { data: BodyType<BulkSetAvailabilityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkSetAvailability>>,
  TError,
  { data: BodyType<BulkSetAvailabilityBody> },
  TContext
> => {
  const mutationKey = ["bulkSetAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkSetAvailability>>,
    { data: BodyType<BulkSetAvailabilityBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkSetAvailability(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkSetAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkSetAvailability>>
>;
export type BulkSetAvailabilityMutationBody = BodyType<BulkSetAvailabilityBody>;
export type BulkSetAvailabilityMutationError = ErrorType<unknown>;

/**
 * @summary Set availability across multiple locations
 */
export const useBulkSetAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkSetAvailability>>,
    TError,
    { data: BodyType<BulkSetAvailabilityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkSetAvailability>>,
  TError,
  { data: BodyType<BulkSetAvailabilityBody> },
  TContext
> => {
  return useMutation(getBulkSetAvailabilityMutationOptions(options));
};

/**
 * @summary Get available time slots for next 30 days
 */
export const getGetOpenSlotsUrl = (
  trainerId: string,
  params?: GetOpenSlotsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/availability/open-slots/${trainerId}?${stringifiedParams}`
    : `/api/availability/open-slots/${trainerId}`;
};

export const getOpenSlots = async (
  trainerId: string,
  params?: GetOpenSlotsParams,
  options?: RequestInit,
): Promise<TimeSlot[]> => {
  return customFetch<TimeSlot[]>(getGetOpenSlotsUrl(trainerId, params), {
    ...options,
    method: "GET",
  });
};

export const getGetOpenSlotsQueryKey = (
  trainerId: string,
  params?: GetOpenSlotsParams,
) => {
  return [
    `/api/availability/open-slots/${trainerId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOpenSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOpenSlots>>,
  TError = ErrorType<unknown>,
>(
  trainerId: string,
  params?: GetOpenSlotsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpenSlots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOpenSlotsQueryKey(trainerId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenSlots>>> = ({
    signal,
  }) => getOpenSlots(trainerId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!trainerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOpenSlots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOpenSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOpenSlots>>
>;
export type GetOpenSlotsQueryError = ErrorType<unknown>;

/**
 * @summary Get available time slots for next 30 days
 */

export function useGetOpenSlots<
  TData = Awaited<ReturnType<typeof getOpenSlots>>,
  TError = ErrorType<unknown>,
>(
  trainerId: string,
  params?: GetOpenSlotsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpenSlots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOpenSlotsQueryOptions(trainerId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Join slot waitlist for a trainer
 */
export const getJoinSlotWaitlistUrl = (trainerId: string) => {
  return `/api/trainers/${trainerId}/waitlist`;
};

export const joinSlotWaitlist = async (
  trainerId: string,
  joinSlotWaitlistBody: JoinSlotWaitlistBody,
  options?: RequestInit,
): Promise<SlotWaitlistEntry> => {
  return customFetch<SlotWaitlistEntry>(getJoinSlotWaitlistUrl(trainerId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(joinSlotWaitlistBody),
  });
};

export const getJoinSlotWaitlistMutationOptions = <
  TError = ErrorType<MessageResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinSlotWaitlist>>,
    TError,
    { trainerId: string; data: BodyType<JoinSlotWaitlistBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinSlotWaitlist>>,
  TError,
  { trainerId: string; data: BodyType<JoinSlotWaitlistBody> },
  TContext
> => {
  const mutationKey = ["joinSlotWaitlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinSlotWaitlist>>,
    { trainerId: string; data: BodyType<JoinSlotWaitlistBody> }
  > = (props) => {
    const { trainerId, data } = props ?? {};

    return joinSlotWaitlist(trainerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinSlotWaitlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof joinSlotWaitlist>>
>;
export type JoinSlotWaitlistMutationBody = BodyType<JoinSlotWaitlistBody>;
export type JoinSlotWaitlistMutationError = ErrorType<MessageResponse>;

/**
 * @summary Join slot waitlist for a trainer
 */
export const useJoinSlotWaitlist = <
  TError = ErrorType<MessageResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinSlotWaitlist>>,
    TError,
    { trainerId: string; data: BodyType<JoinSlotWaitlistBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof joinSlotWaitlist>>,
  TError,
  { trainerId: string; data: BodyType<JoinSlotWaitlistBody> },
  TContext
> => {
  return useMutation(getJoinSlotWaitlistMutationOptions(options));
};

/**
 * @summary Leave slot waitlist
 */
export const getLeaveSlotWaitlistUrl = (trainerId: string, entryId: string) => {
  return `/api/trainers/${trainerId}/waitlist/${entryId}`;
};

export const leaveSlotWaitlist = async (
  trainerId: string,
  entryId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getLeaveSlotWaitlistUrl(trainerId, entryId), {
    ...options,
    method: "DELETE",
  });
};

export const getLeaveSlotWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveSlotWaitlist>>,
    TError,
    { trainerId: string; entryId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leaveSlotWaitlist>>,
  TError,
  { trainerId: string; entryId: string },
  TContext
> => {
  const mutationKey = ["leaveSlotWaitlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveSlotWaitlist>>,
    { trainerId: string; entryId: string }
  > = (props) => {
    const { trainerId, entryId } = props ?? {};

    return leaveSlotWaitlist(trainerId, entryId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LeaveSlotWaitlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof leaveSlotWaitlist>>
>;

export type LeaveSlotWaitlistMutationError = ErrorType<unknown>;

/**
 * @summary Leave slot waitlist
 */
export const useLeaveSlotWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveSlotWaitlist>>,
    TError,
    { trainerId: string; entryId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof leaveSlotWaitlist>>,
  TError,
  { trainerId: string; entryId: string },
  TContext
> => {
  return useMutation(getLeaveSlotWaitlistMutationOptions(options));
};

/**
 * @summary Get active slot waitlist entries for current user
 */
export const getGetMySlotWaitlistUrl = () => {
  return `/api/my/waitlist`;
};

export const getMySlotWaitlist = async (
  options?: RequestInit,
): Promise<SlotWaitlistEntryWithTrainer[]> => {
  return customFetch<SlotWaitlistEntryWithTrainer[]>(
    getGetMySlotWaitlistUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMySlotWaitlistQueryKey = () => {
  return [`/api/my/waitlist`] as const;
};

export const getGetMySlotWaitlistQueryOptions = <
  TData = Awaited<ReturnType<typeof getMySlotWaitlist>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMySlotWaitlist>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMySlotWaitlistQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMySlotWaitlist>>
  > = ({ signal }) => getMySlotWaitlist({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMySlotWaitlist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMySlotWaitlistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMySlotWaitlist>>
>;
export type GetMySlotWaitlistQueryError = ErrorType<unknown>;

/**
 * @summary Get active slot waitlist entries for current user
 */

export function useGetMySlotWaitlist<
  TData = Awaited<ReturnType<typeof getMySlotWaitlist>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMySlotWaitlist>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMySlotWaitlistQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get trainer's client list
 */
export const getGetTrainerClientsUrl = () => {
  return `/api/trainers/clients`;
};

export const getTrainerClients = async (
  options?: RequestInit,
): Promise<TrainerClient[]> => {
  return customFetch<TrainerClient[]>(getGetTrainerClientsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainerClientsQueryKey = () => {
  return [`/api/trainers/clients`] as const;
};

export const getGetTrainerClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerClients>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerClients>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainerClientsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerClients>>
  > = ({ signal }) => getTrainerClients({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerClients>>
>;
export type GetTrainerClientsQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer's client list
 */

export function useGetTrainerClients<
  TData = Awaited<ReturnType<typeof getTrainerClients>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerClients>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerClientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send SMS to a client
 */
export const getSendClientSmsUrl = (clientId: string) => {
  return `/api/trainers/clients/${clientId}/sms`;
};

export const sendClientSms = async (
  clientId: string,
  sendClientSmsBody: SendClientSmsBody,
  options?: RequestInit,
): Promise<SmsResult> => {
  return customFetch<SmsResult>(getSendClientSmsUrl(clientId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendClientSmsBody),
  });
};

export const getSendClientSmsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendClientSms>>,
    TError,
    { clientId: string; data: BodyType<SendClientSmsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendClientSms>>,
  TError,
  { clientId: string; data: BodyType<SendClientSmsBody> },
  TContext
> => {
  const mutationKey = ["sendClientSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendClientSms>>,
    { clientId: string; data: BodyType<SendClientSmsBody> }
  > = (props) => {
    const { clientId, data } = props ?? {};

    return sendClientSms(clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendClientSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendClientSms>>
>;
export type SendClientSmsMutationBody = BodyType<SendClientSmsBody>;
export type SendClientSmsMutationError = ErrorType<unknown>;

/**
 * @summary Send SMS to a client
 */
export const useSendClientSms = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendClientSms>>,
    TError,
    { clientId: string; data: BodyType<SendClientSmsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendClientSms>>,
  TError,
  { clientId: string; data: BodyType<SendClientSmsBody> },
  TContext
> => {
  return useMutation(getSendClientSmsMutationOptions(options));
};

/**
 * @summary Get trainer's message templates
 */
export const getGetTrainerMessageTemplatesUrl = () => {
  return `/api/trainers/message-templates`;
};

export const getTrainerMessageTemplates = async (
  options?: RequestInit,
): Promise<TrainerMessageTemplate[]> => {
  return customFetch<TrainerMessageTemplate[]>(
    getGetTrainerMessageTemplatesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainerMessageTemplatesQueryKey = () => {
  return [`/api/trainers/message-templates`] as const;
};

export const getGetTrainerMessageTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainerMessageTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerMessageTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrainerMessageTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainerMessageTemplates>>
  > = ({ signal }) => getTrainerMessageTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerMessageTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrainerMessageTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainerMessageTemplates>>
>;
export type GetTrainerMessageTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer's message templates
 */

export function useGetTrainerMessageTemplates<
  TData = Awaited<ReturnType<typeof getTrainerMessageTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrainerMessageTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrainerMessageTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a message template
 */
export const getCreateTrainerMessageTemplateUrl = () => {
  return `/api/trainers/message-templates`;
};

export const createTrainerMessageTemplate = async (
  createTrainerMessageTemplateBody: CreateTrainerMessageTemplateBody,
  options?: RequestInit,
): Promise<TrainerMessageTemplate> => {
  return customFetch<TrainerMessageTemplate>(
    getCreateTrainerMessageTemplateUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createTrainerMessageTemplateBody),
    },
  );
};

export const getCreateTrainerMessageTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainerMessageTemplate>>,
    TError,
    { data: BodyType<CreateTrainerMessageTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrainerMessageTemplate>>,
  TError,
  { data: BodyType<CreateTrainerMessageTemplateBody> },
  TContext
> => {
  const mutationKey = ["createTrainerMessageTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrainerMessageTemplate>>,
    { data: BodyType<CreateTrainerMessageTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrainerMessageTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrainerMessageTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrainerMessageTemplate>>
>;
export type CreateTrainerMessageTemplateMutationBody =
  BodyType<CreateTrainerMessageTemplateBody>;
export type CreateTrainerMessageTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create a message template
 */
export const useCreateTrainerMessageTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainerMessageTemplate>>,
    TError,
    { data: BodyType<CreateTrainerMessageTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrainerMessageTemplate>>,
  TError,
  { data: BodyType<CreateTrainerMessageTemplateBody> },
  TContext
> => {
  return useMutation(getCreateTrainerMessageTemplateMutationOptions(options));
};

/**
 * @summary Update a message template
 */
export const getUpdateTrainerMessageTemplateUrl = (id: string) => {
  return `/api/trainers/message-templates/${id}`;
};

export const updateTrainerMessageTemplate = async (
  id: string,
  updateTrainerMessageTemplateBody: UpdateTrainerMessageTemplateBody,
  options?: RequestInit,
): Promise<TrainerMessageTemplate> => {
  return customFetch<TrainerMessageTemplate>(
    getUpdateTrainerMessageTemplateUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateTrainerMessageTemplateBody),
    },
  );
};

export const getUpdateTrainerMessageTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerMessageTemplate>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerMessageTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrainerMessageTemplate>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerMessageTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateTrainerMessageTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrainerMessageTemplate>>,
    { id: string; data: BodyType<UpdateTrainerMessageTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrainerMessageTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrainerMessageTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrainerMessageTemplate>>
>;
export type UpdateTrainerMessageTemplateMutationBody =
  BodyType<UpdateTrainerMessageTemplateBody>;
export type UpdateTrainerMessageTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update a message template
 */
export const useUpdateTrainerMessageTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrainerMessageTemplate>>,
    TError,
    { id: string; data: BodyType<UpdateTrainerMessageTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrainerMessageTemplate>>,
  TError,
  { id: string; data: BodyType<UpdateTrainerMessageTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateTrainerMessageTemplateMutationOptions(options));
};

/**
 * @summary Delete a message template
 */
export const getDeleteTrainerMessageTemplateUrl = (id: string) => {
  return `/api/trainers/message-templates/${id}`;
};

export const deleteTrainerMessageTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteTrainerMessageTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrainerMessageTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTrainerMessageTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrainerMessageTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrainerMessageTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>
>;

export type DeleteTrainerMessageTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a message template
 */
export const useDeleteTrainerMessageTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrainerMessageTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTrainerMessageTemplateMutationOptions(options));
};

/**
 * @summary Book a private session
 */
export const getCreateSessionUrl = () => {
  return `/api/sessions`;
};

export const createSession = async (
  createSessionInput: CreateSessionInput,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getCreateSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSessionInput),
  });
};

export const getCreateSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSession>>,
    TError,
    { data: BodyType<CreateSessionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: BodyType<CreateSessionInput> },
  TContext
> => {
  const mutationKey = ["createSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSession>>,
    { data: BodyType<CreateSessionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSession>>
>;
export type CreateSessionMutationBody = BodyType<CreateSessionInput>;
export type CreateSessionMutationError = ErrorType<unknown>;

/**
 * @summary Book a private session
 */
export const useCreateSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSession>>,
    TError,
    { data: BodyType<CreateSessionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: BodyType<CreateSessionInput> },
  TContext
> => {
  return useMutation(getCreateSessionMutationOptions(options));
};

/**
 * @summary Get own sessions
 */
export const getGetMySessionsUrl = (params?: GetMySessionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sessions/my?${stringifiedParams}`
    : `/api/sessions/my`;
};

export const getMySessions = async (
  params?: GetMySessionsParams,
  options?: RequestInit,
): Promise<PrivateSession[]> => {
  return customFetch<PrivateSession[]>(getGetMySessionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMySessionsQueryKey = (params?: GetMySessionsParams) => {
  return [`/api/sessions/my`, ...(params ? [params] : [])] as const;
};

export const getGetMySessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMySessions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMySessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMySessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMySessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySessions>>> = ({
    signal,
  }) => getMySessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMySessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMySessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMySessions>>
>;
export type GetMySessionsQueryError = ErrorType<unknown>;

/**
 * @summary Get own sessions
 */

export function useGetMySessions<
  TData = Awaited<ReturnType<typeof getMySessions>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMySessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMySessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMySessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary All gym sessions (admin)
 */
export const getGetGymSessionsUrl = (
  gymId: string,
  params?: GetGymSessionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sessions/gym/${gymId}?${stringifiedParams}`
    : `/api/sessions/gym/${gymId}`;
};

export const getGymSessions = async (
  gymId: string,
  params?: GetGymSessionsParams,
  options?: RequestInit,
): Promise<PrivateSession[]> => {
  return customFetch<PrivateSession[]>(getGetGymSessionsUrl(gymId, params), {
    ...options,
    method: "GET",
  });
};

export const getGetGymSessionsQueryKey = (
  gymId: string,
  params?: GetGymSessionsParams,
) => {
  return [`/api/sessions/gym/${gymId}`, ...(params ? [params] : [])] as const;
};

export const getGetGymSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymSessions>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetGymSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymSessionsQueryKey(gymId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGymSessions>>> = ({
    signal,
  }) => getGymSessions(gymId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymSessions>>
>;
export type GetGymSessionsQueryError = ErrorType<unknown>;

/**
 * @summary All gym sessions (admin)
 */

export function useGetGymSessions<
  TData = Awaited<ReturnType<typeof getGymSessions>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetGymSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymSessionsQueryOptions(gymId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get session detail
 */
export const getGetSessionUrl = (id: string) => {
  return `/api/sessions/${id}`;
};

export const getSession = async (
  id: string,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getGetSessionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSessionQueryKey = (id: string) => {
  return [`/api/sessions/${id}`] as const;
};

export const getGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({
    signal,
  }) => getSession(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSession>>
>;
export type GetSessionQueryError = ErrorType<unknown>;

/**
 * @summary Get session detail
 */

export function useGetSession<
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSessionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Confirm session (trainer)
 */
export const getConfirmSessionUrl = (id: string) => {
  return `/api/sessions/${id}/confirm`;
};

export const confirmSession = async (
  id: string,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getConfirmSessionUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getConfirmSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["confirmSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return confirmSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmSession>>
>;

export type ConfirmSessionMutationError = ErrorType<unknown>;

/**
 * @summary Confirm session (trainer)
 */
export const useConfirmSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getConfirmSessionMutationOptions(options));
};

/**
 * @summary Reject session (trainer)
 */
export const getRejectSessionUrl = (id: string) => {
  return `/api/sessions/${id}/reject`;
};

export const rejectSession = async (
  id: string,
  rejectSessionBody?: RejectSessionBody,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getRejectSessionUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectSessionBody),
  });
};

export const getRejectSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectSession>>,
    TError,
    { id: string; data: BodyType<RejectSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectSession>>,
  TError,
  { id: string; data: BodyType<RejectSessionBody> },
  TContext
> => {
  const mutationKey = ["rejectSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectSession>>,
    { id: string; data: BodyType<RejectSessionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectSession>>
>;
export type RejectSessionMutationBody = BodyType<RejectSessionBody>;
export type RejectSessionMutationError = ErrorType<unknown>;

/**
 * @summary Reject session (trainer)
 */
export const useRejectSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectSession>>,
    TError,
    { id: string; data: BodyType<RejectSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectSession>>,
  TError,
  { id: string; data: BodyType<RejectSessionBody> },
  TContext
> => {
  return useMutation(getRejectSessionMutationOptions(options));
};

/**
 * @summary Propose time change
 */
export const getAmendSessionUrl = (id: string) => {
  return `/api/sessions/${id}/amend`;
};

export const amendSession = async (
  id: string,
  amendSessionInput: AmendSessionInput,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getAmendSessionUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(amendSessionInput),
  });
};

export const getAmendSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof amendSession>>,
    TError,
    { id: string; data: BodyType<AmendSessionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof amendSession>>,
  TError,
  { id: string; data: BodyType<AmendSessionInput> },
  TContext
> => {
  const mutationKey = ["amendSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof amendSession>>,
    { id: string; data: BodyType<AmendSessionInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return amendSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AmendSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof amendSession>>
>;
export type AmendSessionMutationBody = BodyType<AmendSessionInput>;
export type AmendSessionMutationError = ErrorType<unknown>;

/**
 * @summary Propose time change
 */
export const useAmendSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof amendSession>>,
    TError,
    { id: string; data: BodyType<AmendSessionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof amendSession>>,
  TError,
  { id: string; data: BodyType<AmendSessionInput> },
  TContext
> => {
  return useMutation(getAmendSessionMutationOptions(options));
};

/**
 * @summary Accept or reject amendment
 */
export const getRespondToAmendmentUrl = (id: string) => {
  return `/api/sessions/${id}/amend/respond`;
};

export const respondToAmendment = async (
  id: string,
  respondToAmendmentBody: RespondToAmendmentBody,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getRespondToAmendmentUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(respondToAmendmentBody),
  });
};

export const getRespondToAmendmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof respondToAmendment>>,
    TError,
    { id: string; data: BodyType<RespondToAmendmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof respondToAmendment>>,
  TError,
  { id: string; data: BodyType<RespondToAmendmentBody> },
  TContext
> => {
  const mutationKey = ["respondToAmendment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof respondToAmendment>>,
    { id: string; data: BodyType<RespondToAmendmentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return respondToAmendment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RespondToAmendmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof respondToAmendment>>
>;
export type RespondToAmendmentMutationBody = BodyType<RespondToAmendmentBody>;
export type RespondToAmendmentMutationError = ErrorType<unknown>;

/**
 * @summary Accept or reject amendment
 */
export const useRespondToAmendment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof respondToAmendment>>,
    TError,
    { id: string; data: BodyType<RespondToAmendmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof respondToAmendment>>,
  TError,
  { id: string; data: BodyType<RespondToAmendmentBody> },
  TContext
> => {
  return useMutation(getRespondToAmendmentMutationOptions(options));
};

/**
 * @summary Cancel session
 */
export const getCancelSessionUrl = (id: string) => {
  return `/api/sessions/${id}/cancel`;
};

export const cancelSession = async (
  id: string,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getCancelSessionUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getCancelSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSession>>
>;

export type CancelSessionMutationError = ErrorType<unknown>;

/**
 * @summary Cancel session
 */
export const useCancelSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelSessionMutationOptions(options));
};

/**
 * @summary Mark session complete
 */
export const getCompleteSessionUrl = (id: string) => {
  return `/api/sessions/${id}/complete`;
};

export const completeSession = async (
  id: string,
  options?: RequestInit,
): Promise<PrivateSession> => {
  return customFetch<PrivateSession>(getCompleteSessionUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getCompleteSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["completeSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return completeSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeSession>>
>;

export type CompleteSessionMutationError = ErrorType<unknown>;

/**
 * @summary Mark session complete
 */
export const useCompleteSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCompleteSessionMutationOptions(options));
};

/**
 * @summary List group classes
 */
export const getListClassesUrl = (
  gymId: string,
  params?: ListClassesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/classes/gym/${gymId}?${stringifiedParams}`
    : `/api/classes/gym/${gymId}`;
};

export const listClasses = async (
  gymId: string,
  params?: ListClassesParams,
  options?: RequestInit,
): Promise<GroupClass[]> => {
  return customFetch<GroupClass[]>(getListClassesUrl(gymId, params), {
    ...options,
    method: "GET",
  });
};

export const getListClassesQueryKey = (
  gymId: string,
  params?: ListClassesParams,
) => {
  return [`/api/classes/gym/${gymId}`, ...(params ? [params] : [])] as const;
};

export const getListClassesQueryOptions = <
  TData = Awaited<ReturnType<typeof listClasses>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: ListClassesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClasses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClassesQueryKey(gymId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClasses>>> = ({
    signal,
  }) => listClasses(gymId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listClasses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClassesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClasses>>
>;
export type ListClassesQueryError = ErrorType<unknown>;

/**
 * @summary List group classes
 */

export function useListClasses<
  TData = Awaited<ReturnType<typeof listClasses>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: ListClassesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClasses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClassesQueryOptions(gymId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create group class
 */
export const getCreateClassUrl = () => {
  return `/api/classes`;
};

export const createClass = async (
  createClassInput: CreateClassInput,
  options?: RequestInit,
): Promise<GroupClass> => {
  return customFetch<GroupClass>(getCreateClassUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClassInput),
  });
};

export const getCreateClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClass>>,
    TError,
    { data: BodyType<CreateClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClass>>,
  TError,
  { data: BodyType<CreateClassInput> },
  TContext
> => {
  const mutationKey = ["createClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClass>>,
    { data: BodyType<CreateClassInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createClass(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClass>>
>;
export type CreateClassMutationBody = BodyType<CreateClassInput>;
export type CreateClassMutationError = ErrorType<unknown>;

/**
 * @summary Create group class
 */
export const useCreateClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClass>>,
    TError,
    { data: BodyType<CreateClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClass>>,
  TError,
  { data: BodyType<CreateClassInput> },
  TContext
> => {
  return useMutation(getCreateClassMutationOptions(options));
};

/**
 * @summary Get class detail
 */
export const getGetClassUrl = (id: string) => {
  return `/api/classes/${id}`;
};

export const getClass = async (
  id: string,
  options?: RequestInit,
): Promise<GroupClass> => {
  return customFetch<GroupClass>(getGetClassUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetClassQueryKey = (id: string) => {
  return [`/api/classes/${id}`] as const;
};

export const getGetClassQueryOptions = <
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClass>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClass>>> = ({
    signal,
  }) => getClass(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetClassQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClass>>
>;
export type GetClassQueryError = ErrorType<unknown>;

/**
 * @summary Get class detail
 */

export function useGetClass<
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClass>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClassQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update class
 */
export const getUpdateClassUrl = (id: string) => {
  return `/api/classes/${id}`;
};

export const updateClass = async (
  id: string,
  updateClassInput: UpdateClassInput,
  options?: RequestInit,
): Promise<GroupClass> => {
  return customFetch<GroupClass>(getUpdateClassUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClassInput),
  });
};

export const getUpdateClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClass>>,
    TError,
    { id: string; data: BodyType<UpdateClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClass>>,
  TError,
  { id: string; data: BodyType<UpdateClassInput> },
  TContext
> => {
  const mutationKey = ["updateClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClass>>,
    { id: string; data: BodyType<UpdateClassInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClass(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClass>>
>;
export type UpdateClassMutationBody = BodyType<UpdateClassInput>;
export type UpdateClassMutationError = ErrorType<unknown>;

/**
 * @summary Update class
 */
export const useUpdateClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClass>>,
    TError,
    { id: string; data: BodyType<UpdateClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClass>>,
  TError,
  { id: string; data: BodyType<UpdateClassInput> },
  TContext
> => {
  return useMutation(getUpdateClassMutationOptions(options));
};

/**
 * @summary Cancel class
 */
export const getCancelClassUrl = (id: string) => {
  return `/api/classes/${id}`;
};

export const cancelClass = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getCancelClassUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelClass>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelClass>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelClass>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelClass(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelClass>>
>;

export type CancelClassMutationError = ErrorType<unknown>;

/**
 * @summary Cancel class
 */
export const useCancelClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelClass>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelClass>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelClassMutationOptions(options));
};

/**
 * @summary Enroll in class
 */
export const getEnrollInClassUrl = (id: string) => {
  return `/api/classes/${id}/enroll`;
};

export const enrollInClass = async (
  id: string,
  enrollInput: EnrollInput,
  options?: RequestInit,
): Promise<ClassEnrollment> => {
  return customFetch<ClassEnrollment>(getEnrollInClassUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(enrollInput),
  });
};

export const getEnrollInClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollInClass>>,
    TError,
    { id: string; data: BodyType<EnrollInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrollInClass>>,
  TError,
  { id: string; data: BodyType<EnrollInput> },
  TContext
> => {
  const mutationKey = ["enrollInClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrollInClass>>,
    { id: string; data: BodyType<EnrollInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return enrollInClass(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrollInClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrollInClass>>
>;
export type EnrollInClassMutationBody = BodyType<EnrollInput>;
export type EnrollInClassMutationError = ErrorType<unknown>;

/**
 * @summary Enroll in class
 */
export const useEnrollInClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollInClass>>,
    TError,
    { id: string; data: BodyType<EnrollInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enrollInClass>>,
  TError,
  { id: string; data: BodyType<EnrollInput> },
  TContext
> => {
  return useMutation(getEnrollInClassMutationOptions(options));
};

/**
 * @summary Cancel enrollment
 */
export const getCancelEnrollmentUrl = (id: string) => {
  return `/api/classes/${id}/enroll`;
};

export const cancelEnrollment = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getCancelEnrollmentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelEnrollmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelEnrollment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelEnrollment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelEnrollment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelEnrollment>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelEnrollment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelEnrollmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelEnrollment>>
>;

export type CancelEnrollmentMutationError = ErrorType<unknown>;

/**
 * @summary Cancel enrollment
 */
export const useCancelEnrollment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelEnrollment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelEnrollment>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelEnrollmentMutationOptions(options));
};

/**
 * @summary Join waitlist
 */
export const getJoinWaitlistUrl = (id: string) => {
  return `/api/classes/${id}/waitlist`;
};

export const joinWaitlist = async (
  id: string,
  options?: RequestInit,
): Promise<WaitlistEntry> => {
  return customFetch<WaitlistEntry>(getJoinWaitlistUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getJoinWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinWaitlist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinWaitlist>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["joinWaitlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinWaitlist>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return joinWaitlist(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinWaitlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof joinWaitlist>>
>;

export type JoinWaitlistMutationError = ErrorType<unknown>;

/**
 * @summary Join waitlist
 */
export const useJoinWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinWaitlist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof joinWaitlist>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getJoinWaitlistMutationOptions(options));
};

/**
 * @summary Leave waitlist
 */
export const getLeaveWaitlistUrl = (id: string) => {
  return `/api/classes/${id}/waitlist`;
};

export const leaveWaitlist = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getLeaveWaitlistUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getLeaveWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveWaitlist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leaveWaitlist>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["leaveWaitlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveWaitlist>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return leaveWaitlist(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LeaveWaitlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof leaveWaitlist>>
>;

export type LeaveWaitlistMutationError = ErrorType<unknown>;

/**
 * @summary Leave waitlist
 */
export const useLeaveWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveWaitlist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof leaveWaitlist>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getLeaveWaitlistMutationOptions(options));
};

/**
 * @summary Get enrolled students
 */
export const getGetClassRosterUrl = (id: string) => {
  return `/api/classes/${id}/roster`;
};

export const getClassRoster = async (
  id: string,
  options?: RequestInit,
): Promise<ClassEnrollment[]> => {
  return customFetch<ClassEnrollment[]>(getGetClassRosterUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetClassRosterQueryKey = (id: string) => {
  return [`/api/classes/${id}/roster`] as const;
};

export const getGetClassRosterQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassRoster>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClassRoster>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassRosterQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassRoster>>> = ({
    signal,
  }) => getClassRoster(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassRoster>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClassRosterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassRoster>>
>;
export type GetClassRosterQueryError = ErrorType<unknown>;

/**
 * @summary Get enrolled students
 */

export function useGetClassRoster<
  TData = Awaited<ReturnType<typeof getClassRoster>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClassRoster>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClassRosterQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark class completed
 */
export const getCompleteClassUrl = (id: string) => {
  return `/api/classes/${id}/complete`;
};

export const completeClass = async (
  id: string,
  options?: RequestInit,
): Promise<GroupClass> => {
  return customFetch<GroupClass>(getCompleteClassUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getCompleteClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeClass>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeClass>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["completeClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeClass>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return completeClass(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeClass>>
>;

export type CompleteClassMutationError = ErrorType<unknown>;

/**
 * @summary Mark class completed
 */
export const useCompleteClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeClass>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeClass>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCompleteClassMutationOptions(options));
};

/**
 * @summary List active packages for gym
 */
export const getListPackagesUrl = (gymId: string) => {
  return `/api/packages/gym/${gymId}`;
};

export const listPackages = async (
  gymId: string,
  options?: RequestInit,
): Promise<SessionPackage[]> => {
  return customFetch<SessionPackage[]>(getListPackagesUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getListPackagesQueryKey = (gymId: string) => {
  return [`/api/packages/gym/${gymId}`] as const;
};

export const getListPackagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPackages>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPackages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPackagesQueryKey(gymId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackages>>> = ({
    signal,
  }) => listPackages(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPackages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPackagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPackages>>
>;
export type ListPackagesQueryError = ErrorType<unknown>;

/**
 * @summary List active packages for gym
 */

export function useListPackages<
  TData = Awaited<ReturnType<typeof listPackages>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPackages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPackagesQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create session package
 */
export const getCreatePackageUrl = () => {
  return `/api/packages`;
};

export const createPackage = async (
  createPackageInput: CreatePackageInput,
  options?: RequestInit,
): Promise<SessionPackage> => {
  return customFetch<SessionPackage>(getCreatePackageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPackageInput),
  });
};

export const getCreatePackageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPackage>>,
    TError,
    { data: BodyType<CreatePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPackage>>,
  TError,
  { data: BodyType<CreatePackageInput> },
  TContext
> => {
  const mutationKey = ["createPackage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPackage>>,
    { data: BodyType<CreatePackageInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createPackage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPackage>>
>;
export type CreatePackageMutationBody = BodyType<CreatePackageInput>;
export type CreatePackageMutationError = ErrorType<unknown>;

/**
 * @summary Create session package
 */
export const useCreatePackage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPackage>>,
    TError,
    { data: BodyType<CreatePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPackage>>,
  TError,
  { data: BodyType<CreatePackageInput> },
  TContext
> => {
  return useMutation(getCreatePackageMutationOptions(options));
};

/**
 * @summary Update package
 */
export const getUpdatePackageUrl = (id: string) => {
  return `/api/packages/${id}`;
};

export const updatePackage = async (
  id: string,
  updatePackageInput: UpdatePackageInput,
  options?: RequestInit,
): Promise<SessionPackage> => {
  return customFetch<SessionPackage>(getUpdatePackageUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePackageInput),
  });
};

export const getUpdatePackageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePackage>>,
    TError,
    { id: string; data: BodyType<UpdatePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePackage>>,
  TError,
  { id: string; data: BodyType<UpdatePackageInput> },
  TContext
> => {
  const mutationKey = ["updatePackage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePackage>>,
    { id: string; data: BodyType<UpdatePackageInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePackage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePackage>>
>;
export type UpdatePackageMutationBody = BodyType<UpdatePackageInput>;
export type UpdatePackageMutationError = ErrorType<unknown>;

/**
 * @summary Update package
 */
export const useUpdatePackage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePackage>>,
    TError,
    { id: string; data: BodyType<UpdatePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePackage>>,
  TError,
  { id: string; data: BodyType<UpdatePackageInput> },
  TContext
> => {
  return useMutation(getUpdatePackageMutationOptions(options));
};

/**
 * @summary Soft delete package
 */
export const getDeletePackageUrl = (id: string) => {
  return `/api/packages/${id}`;
};

export const deletePackage = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeletePackageUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePackageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePackage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePackage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePackage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePackage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePackage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePackage>>
>;

export type DeletePackageMutationError = ErrorType<unknown>;

/**
 * @summary Soft delete package
 */
export const useDeletePackage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePackage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePackage>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePackageMutationOptions(options));
};

/**
 * @summary Buy package (student)
 */
export const getPurchasePackageUrl = () => {
  return `/api/packages/purchase`;
};

export const purchasePackage = async (
  purchasePackageInput: PurchasePackageInput,
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getPurchasePackageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(purchasePackageInput),
  });
};

export const getPurchasePackageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchasePackage>>,
    TError,
    { data: BodyType<PurchasePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchasePackage>>,
  TError,
  { data: BodyType<PurchasePackageInput> },
  TContext
> => {
  const mutationKey = ["purchasePackage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchasePackage>>,
    { data: BodyType<PurchasePackageInput> }
  > = (props) => {
    const { data } = props ?? {};

    return purchasePackage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchasePackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchasePackage>>
>;
export type PurchasePackageMutationBody = BodyType<PurchasePackageInput>;
export type PurchasePackageMutationError = ErrorType<unknown>;

/**
 * @summary Buy package (student)
 */
export const usePurchasePackage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchasePackage>>,
    TError,
    { data: BodyType<PurchasePackageInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof purchasePackage>>,
  TError,
  { data: BodyType<PurchasePackageInput> },
  TContext
> => {
  return useMutation(getPurchasePackageMutationOptions(options));
};

/**
 * @summary Get student credits
 */
export const getGetMyCreditsUrl = () => {
  return `/api/packages/my-credits`;
};

export const getMyCredits = async (
  options?: RequestInit,
): Promise<PackagePurchase[]> => {
  return customFetch<PackagePurchase[]>(getGetMyCreditsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyCreditsQueryKey = () => {
  return [`/api/packages/my-credits`] as const;
};

export const getGetMyCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCredits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyCredits>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCreditsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCredits>>> = ({
    signal,
  }) => getMyCredits({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCredits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCredits>>
>;
export type GetMyCreditsQueryError = ErrorType<unknown>;

/**
 * @summary Get student credits
 */

export function useGetMyCredits<
  TData = Awaited<ReturnType<typeof getMyCredits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyCredits>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyCreditsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Toggle auto-renewal for a package purchase
 */
export const getUpdateAutoRenewUrl = (id: string) => {
  return `/api/packages/purchases/${id}/auto-renew`;
};

export const updateAutoRenew = async (
  id: string,
  autoRenewInput: AutoRenewInput,
  options?: RequestInit,
): Promise<PackagePurchase> => {
  return customFetch<PackagePurchase>(getUpdateAutoRenewUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(autoRenewInput),
  });
};

export const getUpdateAutoRenewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutoRenew>>,
    TError,
    { id: string; data: BodyType<AutoRenewInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAutoRenew>>,
  TError,
  { id: string; data: BodyType<AutoRenewInput> },
  TContext
> => {
  const mutationKey = ["updateAutoRenew"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAutoRenew>>,
    { id: string; data: BodyType<AutoRenewInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAutoRenew(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAutoRenewMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAutoRenew>>
>;
export type UpdateAutoRenewMutationBody = BodyType<AutoRenewInput>;
export type UpdateAutoRenewMutationError = ErrorType<unknown>;

/**
 * @summary Toggle auto-renewal for a package purchase
 */
export const useUpdateAutoRenew = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutoRenew>>,
    TError,
    { id: string; data: BodyType<AutoRenewInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAutoRenew>>,
  TError,
  { id: string; data: BodyType<AutoRenewInput> },
  TContext
> => {
  return useMutation(getUpdateAutoRenewMutationOptions(options));
};

/**
 * @summary All package purchases for gym (admin)
 */
export const getGetGymPackagePurchasesUrl = (gymId: string) => {
  return `/api/packages/purchases/gym/${gymId}`;
};

export const getGymPackagePurchases = async (
  gymId: string,
  options?: RequestInit,
): Promise<PackagePurchase[]> => {
  return customFetch<PackagePurchase[]>(getGetGymPackagePurchasesUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getGetGymPackagePurchasesQueryKey = (gymId: string) => {
  return [`/api/packages/purchases/gym/${gymId}`] as const;
};

export const getGetGymPackagePurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymPackagePurchases>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPackagePurchases>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymPackagePurchasesQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymPackagePurchases>>
  > = ({ signal }) =>
    getGymPackagePurchases(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymPackagePurchases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymPackagePurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymPackagePurchases>>
>;
export type GetGymPackagePurchasesQueryError = ErrorType<unknown>;

/**
 * @summary All package purchases for gym (admin)
 */

export function useGetGymPackagePurchases<
  TData = Awaited<ReturnType<typeof getGymPackagePurchases>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPackagePurchases>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymPackagePurchasesQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List membership plans for gym
 */
export const getListMembershipPlansUrl = (gymId: string) => {
  return `/api/memberships/plans/gym/${gymId}`;
};

export const listMembershipPlans = async (
  gymId: string,
  options?: RequestInit,
): Promise<MembershipPlan[]> => {
  return customFetch<MembershipPlan[]>(getListMembershipPlansUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getListMembershipPlansQueryKey = (gymId: string) => {
  return [`/api/memberships/plans/gym/${gymId}`] as const;
};

export const getListMembershipPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listMembershipPlans>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMembershipPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMembershipPlansQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMembershipPlans>>
  > = ({ signal }) => listMembershipPlans(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMembershipPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMembershipPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMembershipPlans>>
>;
export type ListMembershipPlansQueryError = ErrorType<unknown>;

/**
 * @summary List membership plans for gym
 */

export function useListMembershipPlans<
  TData = Awaited<ReturnType<typeof listMembershipPlans>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMembershipPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMembershipPlansQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all membership plans for gym (admin)
 */
export const getListAllMembershipPlansUrl = (gymId: string) => {
  return `/api/memberships/plans/gym/${gymId}/all`;
};

export const listAllMembershipPlans = async (
  gymId: string,
  options?: RequestInit,
): Promise<MembershipPlan[]> => {
  return customFetch<MembershipPlan[]>(getListAllMembershipPlansUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getListAllMembershipPlansQueryKey = (gymId: string) => {
  return [`/api/memberships/plans/gym/${gymId}/all`] as const;
};

export const getListAllMembershipPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllMembershipPlans>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllMembershipPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAllMembershipPlansQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllMembershipPlans>>
  > = ({ signal }) =>
    listAllMembershipPlans(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllMembershipPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllMembershipPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllMembershipPlans>>
>;
export type ListAllMembershipPlansQueryError = ErrorType<unknown>;

/**
 * @summary List all membership plans for gym (admin)
 */

export function useListAllMembershipPlans<
  TData = Awaited<ReturnType<typeof listAllMembershipPlans>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllMembershipPlans>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllMembershipPlansQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create membership plan
 */
export const getCreateMembershipPlanUrl = () => {
  return `/api/memberships/plans`;
};

export const createMembershipPlan = async (
  createMembershipPlanInput: CreateMembershipPlanInput,
  options?: RequestInit,
): Promise<MembershipPlan> => {
  return customFetch<MembershipPlan>(getCreateMembershipPlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMembershipPlanInput),
  });
};

export const getCreateMembershipPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMembershipPlan>>,
    TError,
    { data: BodyType<CreateMembershipPlanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMembershipPlan>>,
  TError,
  { data: BodyType<CreateMembershipPlanInput> },
  TContext
> => {
  const mutationKey = ["createMembershipPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMembershipPlan>>,
    { data: BodyType<CreateMembershipPlanInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createMembershipPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMembershipPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMembershipPlan>>
>;
export type CreateMembershipPlanMutationBody =
  BodyType<CreateMembershipPlanInput>;
export type CreateMembershipPlanMutationError = ErrorType<unknown>;

/**
 * @summary Create membership plan
 */
export const useCreateMembershipPlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMembershipPlan>>,
    TError,
    { data: BodyType<CreateMembershipPlanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMembershipPlan>>,
  TError,
  { data: BodyType<CreateMembershipPlanInput> },
  TContext
> => {
  return useMutation(getCreateMembershipPlanMutationOptions(options));
};

/**
 * @summary Update membership plan
 */
export const getUpdateMembershipPlanUrl = (id: string) => {
  return `/api/memberships/plans/${id}`;
};

export const updateMembershipPlan = async (
  id: string,
  updateMembershipPlanInput: UpdateMembershipPlanInput,
  options?: RequestInit,
): Promise<MembershipPlan> => {
  return customFetch<MembershipPlan>(getUpdateMembershipPlanUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMembershipPlanInput),
  });
};

export const getUpdateMembershipPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMembershipPlan>>,
    TError,
    { id: string; data: BodyType<UpdateMembershipPlanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMembershipPlan>>,
  TError,
  { id: string; data: BodyType<UpdateMembershipPlanInput> },
  TContext
> => {
  const mutationKey = ["updateMembershipPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMembershipPlan>>,
    { id: string; data: BodyType<UpdateMembershipPlanInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMembershipPlan(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMembershipPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMembershipPlan>>
>;
export type UpdateMembershipPlanMutationBody =
  BodyType<UpdateMembershipPlanInput>;
export type UpdateMembershipPlanMutationError = ErrorType<unknown>;

/**
 * @summary Update membership plan
 */
export const useUpdateMembershipPlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMembershipPlan>>,
    TError,
    { id: string; data: BodyType<UpdateMembershipPlanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMembershipPlan>>,
  TError,
  { id: string; data: BodyType<UpdateMembershipPlanInput> },
  TContext
> => {
  return useMutation(getUpdateMembershipPlanMutationOptions(options));
};

/**
 * @summary Deactivate plan
 */
export const getDeleteMembershipPlanUrl = (id: string) => {
  return `/api/memberships/plans/${id}`;
};

export const deleteMembershipPlan = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeleteMembershipPlanUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMembershipPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMembershipPlan>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMembershipPlan>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMembershipPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMembershipPlan>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMembershipPlan(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMembershipPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMembershipPlan>>
>;

export type DeleteMembershipPlanMutationError = ErrorType<unknown>;

/**
 * @summary Deactivate plan
 */
export const useDeleteMembershipPlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMembershipPlan>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMembershipPlan>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMembershipPlanMutationOptions(options));
};

/**
 * @summary Subscribe to membership
 */
export const getMembershipCheckoutUrl = () => {
  return `/api/memberships/checkout`;
};

export const membershipCheckout = async (
  membershipCheckoutBody: MembershipCheckoutBody,
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getMembershipCheckoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(membershipCheckoutBody),
  });
};

export const getMembershipCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membershipCheckout>>,
    TError,
    { data: BodyType<MembershipCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membershipCheckout>>,
  TError,
  { data: BodyType<MembershipCheckoutBody> },
  TContext
> => {
  const mutationKey = ["membershipCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membershipCheckout>>,
    { data: BodyType<MembershipCheckoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return membershipCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembershipCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof membershipCheckout>>
>;
export type MembershipCheckoutMutationBody = BodyType<MembershipCheckoutBody>;
export type MembershipCheckoutMutationError = ErrorType<unknown>;

/**
 * @summary Subscribe to membership
 */
export const useMembershipCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membershipCheckout>>,
    TError,
    { data: BodyType<MembershipCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof membershipCheckout>>,
  TError,
  { data: BodyType<MembershipCheckoutBody> },
  TContext
> => {
  return useMutation(getMembershipCheckoutMutationOptions(options));
};

/**
 * @summary Get student active membership
 */
export const getGetMyMembershipUrl = () => {
  return `/api/memberships/my`;
};

export const getMyMembership = async (
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(getGetMyMembershipUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyMembershipQueryKey = () => {
  return [`/api/memberships/my`] as const;
};

export const getGetMyMembershipQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyMembership>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyMembership>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyMembershipQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMembership>>> = ({
    signal,
  }) => getMyMembership({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyMembership>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyMembershipQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyMembership>>
>;
export type GetMyMembershipQueryError = ErrorType<unknown>;

/**
 * @summary Get student active membership
 */

export function useGetMyMembership<
  TData = Awaited<ReturnType<typeof getMyMembership>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyMembership>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyMembershipQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cancel membership at period end
 */
export const getCancelMembershipUrl = (id: string) => {
  return `/api/memberships/${id}/cancel`;
};

export const cancelMembership = async (
  id: string,
  options?: RequestInit,
): Promise<Membership> => {
  return customFetch<Membership>(getCancelMembershipUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getCancelMembershipMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMembership>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMembership>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMembership>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelMembership(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMembership>>
>;

export type CancelMembershipMutationError = ErrorType<unknown>;

/**
 * @summary Cancel membership at period end
 */
export const useCancelMembership = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMembership>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMembership>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelMembershipMutationOptions(options));
};

/**
 * @summary All active memberships at gym (admin)
 */
export const getGetGymMembershipsUrl = (gymId: string) => {
  return `/api/memberships/gym/${gymId}`;
};

export const getGymMemberships = async (
  gymId: string,
  options?: RequestInit,
): Promise<Membership[]> => {
  return customFetch<Membership[]>(getGetGymMembershipsUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getGetGymMembershipsQueryKey = (gymId: string) => {
  return [`/api/memberships/gym/${gymId}`] as const;
};

export const getGetGymMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymMemberships>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymMembershipsQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymMemberships>>
  > = ({ signal }) => getGymMemberships(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymMemberships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymMembershipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymMemberships>>
>;
export type GetGymMembershipsQueryError = ErrorType<unknown>;

/**
 * @summary All active memberships at gym (admin)
 */

export function useGetGymMemberships<
  TData = Awaited<ReturnType<typeof getGymMemberships>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymMembershipsQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Single session checkout
 */
export const getCheckoutSessionUrl = () => {
  return `/api/payments/checkout/session`;
};

export const checkoutSession = async (
  checkoutSessionBody: CheckoutSessionBody,
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getCheckoutSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(checkoutSessionBody),
  });
};

export const getCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutSession>>,
    TError,
    { data: BodyType<CheckoutSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutSession>>,
  TError,
  { data: BodyType<CheckoutSessionBody> },
  TContext
> => {
  const mutationKey = ["checkoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutSession>>,
    { data: BodyType<CheckoutSessionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return checkoutSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkoutSession>>
>;
export type CheckoutSessionMutationBody = BodyType<CheckoutSessionBody>;
export type CheckoutSessionMutationError = ErrorType<unknown>;

/**
 * @summary Single session checkout
 */
export const useCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutSession>>,
    TError,
    { data: BodyType<CheckoutSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkoutSession>>,
  TError,
  { data: BodyType<CheckoutSessionBody> },
  TContext
> => {
  return useMutation(getCheckoutSessionMutationOptions(options));
};

/**
 * @summary Class drop-in checkout
 */
export const getCheckoutClassUrl = () => {
  return `/api/payments/checkout/class`;
};

export const checkoutClass = async (
  checkoutClassBody: CheckoutClassBody,
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getCheckoutClassUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(checkoutClassBody),
  });
};

export const getCheckoutClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutClass>>,
    TError,
    { data: BodyType<CheckoutClassBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutClass>>,
  TError,
  { data: BodyType<CheckoutClassBody> },
  TContext
> => {
  const mutationKey = ["checkoutClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutClass>>,
    { data: BodyType<CheckoutClassBody> }
  > = (props) => {
    const { data } = props ?? {};

    return checkoutClass(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkoutClass>>
>;
export type CheckoutClassMutationBody = BodyType<CheckoutClassBody>;
export type CheckoutClassMutationError = ErrorType<unknown>;

/**
 * @summary Class drop-in checkout
 */
export const useCheckoutClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutClass>>,
    TError,
    { data: BodyType<CheckoutClassBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkoutClass>>,
  TError,
  { data: BodyType<CheckoutClassBody> },
  TContext
> => {
  return useMutation(getCheckoutClassMutationOptions(options));
};

/**
 * @summary Stripe webhook handler
 */
export const getStripeWebhookUrl = () => {
  return `/api/payments/webhook`;
};

export const stripeWebhook = async (
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getStripeWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getStripeWebhookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stripeWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeWebhook>>,
    void
  > = () => {
    return stripeWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeWebhook>>
>;

export type StripeWebhookMutationError = ErrorType<unknown>;

/**
 * @summary Stripe webhook handler
 */
export const useStripeWebhook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof stripeWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getStripeWebhookMutationOptions(options));
};

/**
 * @summary Premium subscription checkout
 */
export const getBillingCheckoutUrl = () => {
  return `/api/billing/checkout`;
};

export const billingCheckout = async (
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getBillingCheckoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getBillingCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingCheckout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["billingCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingCheckout>>,
    void
  > = () => {
    return billingCheckout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingCheckout>>
>;

export type BillingCheckoutMutationError = ErrorType<unknown>;

/**
 * @summary Premium subscription checkout
 */
export const useBillingCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billingCheckout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBillingCheckoutMutationOptions(options));
};

/**
 * @summary Stripe Billing Portal
 */
export const getBillingPortalUrl = () => {
  return `/api/billing/portal`;
};

export const billingPortal = async (
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getBillingPortalUrl(), {
    ...options,
    method: "POST",
  });
};

export const getBillingPortalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingPortal>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["billingPortal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingPortal>>,
    void
  > = () => {
    return billingPortal(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingPortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingPortal>>
>;

export type BillingPortalMutationError = ErrorType<unknown>;

/**
 * @summary Stripe Billing Portal
 */
export const useBillingPortal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingPortal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof billingPortal>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBillingPortalMutationOptions(options));
};

/**
 * @summary Get billing status
 */
export const getGetBillingStatusUrl = (gymId: string) => {
  return `/api/billing/gym/${gymId}`;
};

export const getBillingStatus = async (
  gymId: string,
  options?: RequestInit,
): Promise<BillingStatus> => {
  return customFetch<BillingStatus>(getGetBillingStatusUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingStatusQueryKey = (gymId: string) => {
  return [`/api/billing/gym/${gymId}`] as const;
};

export const getGetBillingStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingStatus>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBillingStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingStatusQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingStatus>>
  > = ({ signal }) => getBillingStatus(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingStatus>>
>;
export type GetBillingStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get billing status
 */

export function useGetBillingStatus<
  TData = Awaited<ReturnType<typeof getBillingStatus>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBillingStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingStatusQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or refresh gym Stripe Connect onboarding link
 */
export const getGymStripeConnectRefreshUrl = (gymId: string) => {
  return `/api/billing/gym/${gymId}/stripe-connect/refresh`;
};

export const gymStripeConnectRefresh = async (
  gymId: string,
  options?: RequestInit,
): Promise<GymStripeConnectRefresh200> => {
  return customFetch<GymStripeConnectRefresh200>(
    getGymStripeConnectRefreshUrl(gymId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getGymStripeConnectRefreshMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gymStripeConnectRefresh>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gymStripeConnectRefresh>>,
  TError,
  { gymId: string },
  TContext
> => {
  const mutationKey = ["gymStripeConnectRefresh"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gymStripeConnectRefresh>>,
    { gymId: string }
  > = (props) => {
    const { gymId } = props ?? {};

    return gymStripeConnectRefresh(gymId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GymStripeConnectRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof gymStripeConnectRefresh>>
>;

export type GymStripeConnectRefreshMutationError = ErrorType<unknown>;

/**
 * @summary Create or refresh gym Stripe Connect onboarding link
 */
export const useGymStripeConnectRefresh = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gymStripeConnectRefresh>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof gymStripeConnectRefresh>>,
  TError,
  { gymId: string },
  TContext
> => {
  return useMutation(getGymStripeConnectRefreshMutationOptions(options));
};

/**
 * @summary Verify gym Stripe Connect onboarding completion
 */
export const getGymStripeConnectCompleteUrl = (gymId: string) => {
  return `/api/billing/gym/${gymId}/stripe-connect/complete`;
};

export const gymStripeConnectComplete = async (
  gymId: string,
  options?: RequestInit,
): Promise<GymStripeConnectComplete200> => {
  return customFetch<GymStripeConnectComplete200>(
    getGymStripeConnectCompleteUrl(gymId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getGymStripeConnectCompleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gymStripeConnectComplete>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gymStripeConnectComplete>>,
  TError,
  { gymId: string },
  TContext
> => {
  const mutationKey = ["gymStripeConnectComplete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gymStripeConnectComplete>>,
    { gymId: string }
  > = (props) => {
    const { gymId } = props ?? {};

    return gymStripeConnectComplete(gymId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GymStripeConnectCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof gymStripeConnectComplete>>
>;

export type GymStripeConnectCompleteMutationError = ErrorType<unknown>;

/**
 * @summary Verify gym Stripe Connect onboarding completion
 */
export const useGymStripeConnectComplete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gymStripeConnectComplete>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof gymStripeConnectComplete>>,
  TError,
  { gymId: string },
  TContext
> => {
  return useMutation(getGymStripeConnectCompleteMutationOptions(options));
};

/**
 * @summary All payout batches for gym
 */
export const getGetGymPayoutsUrl = (gymId: string) => {
  return `/api/payouts/gym/${gymId}`;
};

export const getGymPayouts = async (
  gymId: string,
  options?: RequestInit,
): Promise<PayoutBatch[]> => {
  return customFetch<PayoutBatch[]>(getGetGymPayoutsUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getGetGymPayoutsQueryKey = (gymId: string) => {
  return [`/api/payouts/gym/${gymId}`] as const;
};

export const getGetGymPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymPayouts>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGymPayoutsQueryKey(gymId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGymPayouts>>> = ({
    signal,
  }) => getGymPayouts(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymPayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymPayouts>>
>;
export type GetGymPayoutsQueryError = ErrorType<unknown>;

/**
 * @summary All payout batches for gym
 */

export function useGetGymPayouts<
  TData = Awaited<ReturnType<typeof getGymPayouts>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymPayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymPayoutsQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trainer payout history
 */
export const getGetMyPayoutsUrl = () => {
  return `/api/payouts/my`;
};

export const getMyPayouts = async (
  options?: RequestInit,
): Promise<PayoutBatch[]> => {
  return customFetch<PayoutBatch[]>(getGetMyPayoutsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyPayoutsQueryKey = () => {
  return [`/api/payouts/my`] as const;
};

export const getGetMyPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyPayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPayoutsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPayouts>>> = ({
    signal,
  }) => getMyPayouts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPayouts>>
>;
export type GetMyPayoutsQueryError = ErrorType<unknown>;

/**
 * @summary Trainer payout history
 */

export function useGetMyPayouts<
  TData = Awaited<ReturnType<typeof getMyPayouts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyPayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyPayoutsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Rate a trainer after session
 */
export const getCreateRatingUrl = () => {
  return `/api/ratings`;
};

export const createRating = async (
  createRatingInput: CreateRatingInput,
  options?: RequestInit,
): Promise<Rating> => {
  return customFetch<Rating>(getCreateRatingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRatingInput),
  });
};

export const getCreateRatingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRating>>,
    TError,
    { data: BodyType<CreateRatingInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRating>>,
  TError,
  { data: BodyType<CreateRatingInput> },
  TContext
> => {
  const mutationKey = ["createRating"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRating>>,
    { data: BodyType<CreateRatingInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createRating(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRatingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRating>>
>;
export type CreateRatingMutationBody = BodyType<CreateRatingInput>;
export type CreateRatingMutationError = ErrorType<unknown>;

/**
 * @summary Rate a trainer after session
 */
export const useCreateRating = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRating>>,
    TError,
    { data: BodyType<CreateRatingInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRating>>,
  TError,
  { data: BodyType<CreateRatingInput> },
  TContext
> => {
  return useMutation(getCreateRatingMutationOptions(options));
};

/**
 * @summary Get user notifications
 */
export const getGetNotificationsUrl = () => {
  return `/api/notifications`;
};

export const getNotifications = async (
  options?: RequestInit,
): Promise<Notification[]> => {
  return customFetch<Notification[]>(getGetNotificationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNotificationsQueryKey = () => {
  return [`/api/notifications`] as const;
};

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotifications>>
  > = ({ signal }) => getNotifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotifications>>
>;
export type GetNotificationsQueryError = ErrorType<unknown>;

/**
 * @summary Get user notifications
 */

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark notification as read
 */
export const getMarkNotificationReadUrl = (id: string) => {
  return `/api/notifications/${id}/read`;
};

export const markNotificationRead = async (
  id: string,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getMarkNotificationReadUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getMarkNotificationReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markNotificationRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationRead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationRead>>
>;

export type MarkNotificationReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark notification as read
 */
export const useMarkNotificationRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getMarkNotificationReadMutationOptions(options));
};

/**
 * @summary Mark all notifications as read
 */
export const getMarkAllNotificationsReadUrl = () => {
  return `/api/notifications/read-all`;
};

export const markAllNotificationsRead = async (
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getMarkAllNotificationsReadUrl(), {
    ...options,
    method: "PUT",
  });
};

export const getMarkAllNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    void
  > = () => {
    return markAllNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsRead>>
>;

export type MarkAllNotificationsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark all notifications as read
 */
export const useMarkAllNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllNotificationsReadMutationOptions(options));
};

/**
 * @summary Update notification preferences
 */
export const getUpdateNotificationPreferencesUrl = () => {
  return `/api/notifications/preferences`;
};

export const updateNotificationPreferences = async (
  updateNotificationPreferencesBody: UpdateNotificationPreferencesBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getUpdateNotificationPreferencesUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNotificationPreferencesBody),
  });
};

export const getUpdateNotificationPreferencesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  const mutationKey = ["updateNotificationPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    { data: BodyType<UpdateNotificationPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPreferences>>
>;
export type UpdateNotificationPreferencesMutationBody =
  BodyType<UpdateNotificationPreferencesBody>;
export type UpdateNotificationPreferencesMutationError = ErrorType<unknown>;

/**
 * @summary Update notification preferences
 */
export const useUpdateNotificationPreferences = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesBody> },
  TContext
> => {
  return useMutation(getUpdateNotificationPreferencesMutationOptions(options));
};

/**
 * @summary Admin KPIs
 */
export const getGetAdminDashboardUrl = () => {
  return `/api/admin/dashboard`;
};

export const getAdminDashboard = async (
  options?: RequestInit,
): Promise<AdminDashboard> => {
  return customFetch<AdminDashboard>(getGetAdminDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminDashboardQueryKey = () => {
  return [`/api/admin/dashboard`] as const;
};

export const getGetAdminDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminDashboard>>
  > = ({ signal }) => getAdminDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminDashboard>>
>;
export type GetAdminDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Admin KPIs
 */

export function useGetAdminDashboard<
  TData = Awaited<ReturnType<typeof getAdminDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Login attack history (blocked IPs per hour)
 */
export const getGetAdminLoginAttackHistoryUrl = (
  params?: GetAdminLoginAttackHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/login-attack-history?${stringifiedParams}`
    : `/api/admin/login-attack-history`;
};

export const getAdminLoginAttackHistory = async (
  params?: GetAdminLoginAttackHistoryParams,
  options?: RequestInit,
): Promise<LoginAttackHistoryEntry[]> => {
  return customFetch<LoginAttackHistoryEntry[]>(
    getGetAdminLoginAttackHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminLoginAttackHistoryQueryKey = (
  params?: GetAdminLoginAttackHistoryParams,
) => {
  return [
    `/api/admin/login-attack-history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminLoginAttackHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLoginAttackHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminLoginAttackHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminLoginAttackHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminLoginAttackHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLoginAttackHistory>>
  > = ({ signal }) =>
    getAdminLoginAttackHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLoginAttackHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminLoginAttackHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLoginAttackHistory>>
>;
export type GetAdminLoginAttackHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Login attack history (blocked IPs per hour)
 */

export function useGetAdminLoginAttackHistory<
  TData = Awaited<ReturnType<typeof getAdminLoginAttackHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminLoginAttackHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminLoginAttackHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminLoginAttackHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Admin calendar events
 */
export const getGetAdminCalendarUrl = (params?: GetAdminCalendarParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/calendar?${stringifiedParams}`
    : `/api/admin/calendar`;
};

export const getAdminCalendar = async (
  params?: GetAdminCalendarParams,
  options?: RequestInit,
): Promise<CalendarEvent[]> => {
  return customFetch<CalendarEvent[]>(getGetAdminCalendarUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminCalendarQueryKey = (
  params?: GetAdminCalendarParams,
) => {
  return [`/api/admin/calendar`, ...(params ? [params] : [])] as const;
};

export const getGetAdminCalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminCalendarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCalendar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCalendarQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCalendar>>
  > = ({ signal }) => getAdminCalendar(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCalendar>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminCalendarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCalendar>>
>;
export type GetAdminCalendarQueryError = ErrorType<unknown>;

/**
 * @summary Admin calendar events
 */

export function useGetAdminCalendar<
  TData = Awaited<ReturnType<typeof getAdminCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminCalendarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCalendar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminCalendarQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Aggregated trainer availability for calendar
 */
export const getGetAdminCalendarTrainerAvailabilityUrl = (
  params?: GetAdminCalendarTrainerAvailabilityParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/calendar/trainer-availability?${stringifiedParams}`
    : `/api/admin/calendar/trainer-availability`;
};

export const getAdminCalendarTrainerAvailability = async (
  params?: GetAdminCalendarTrainerAvailabilityParams,
  options?: RequestInit,
): Promise<TrainerAvailabilitySlot[]> => {
  return customFetch<TrainerAvailabilitySlot[]>(
    getGetAdminCalendarTrainerAvailabilityUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminCalendarTrainerAvailabilityQueryKey = (
  params?: GetAdminCalendarTrainerAvailabilityParams,
) => {
  return [
    `/api/admin/calendar/trainer-availability`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminCalendarTrainerAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminCalendarTrainerAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminCalendarTrainerAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>
  > = ({ signal }) =>
    getAdminCalendarTrainerAvailability(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminCalendarTrainerAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>
>;
export type GetAdminCalendarTrainerAvailabilityQueryError = ErrorType<unknown>;

/**
 * @summary Aggregated trainer availability for calendar
 */

export function useGetAdminCalendarTrainerAvailability<
  TData = Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminCalendarTrainerAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCalendarTrainerAvailability>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminCalendarTrainerAvailabilityQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Payroll report
 */
export const getGetAdminPayrollUrl = (params?: GetAdminPayrollParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/payroll?${stringifiedParams}`
    : `/api/admin/payroll`;
};

export const getAdminPayroll = async (
  params?: GetAdminPayrollParams,
  options?: RequestInit,
): Promise<PayrollEntry[]> => {
  return customFetch<PayrollEntry[]>(getGetAdminPayrollUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminPayrollQueryKey = (params?: GetAdminPayrollParams) => {
  return [`/api/admin/payroll`, ...(params ? [params] : [])] as const;
};

export const getGetAdminPayrollQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminPayroll>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminPayrollParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminPayroll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminPayrollQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPayroll>>> = ({
    signal,
  }) => getAdminPayroll(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminPayroll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminPayrollQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminPayroll>>
>;
export type GetAdminPayrollQueryError = ErrorType<unknown>;

/**
 * @summary Payroll report
 */

export function useGetAdminPayroll<
  TData = Awaited<ReturnType<typeof getAdminPayroll>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminPayrollParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminPayroll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminPayrollQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Peak booking hours heatmap
 */
export const getGetAnalyticsPeakHoursUrl = (
  gymId: string,
  params?: GetAnalyticsPeakHoursParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics/${gymId}/peak-hours?${stringifiedParams}`
    : `/api/admin/analytics/${gymId}/peak-hours`;
};

export const getAnalyticsPeakHours = async (
  gymId: string,
  params?: GetAnalyticsPeakHoursParams,
  options?: RequestInit,
): Promise<PeakHoursData> => {
  return customFetch<PeakHoursData>(
    getGetAnalyticsPeakHoursUrl(gymId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAnalyticsPeakHoursQueryKey = (
  gymId: string,
  params?: GetAnalyticsPeakHoursParams,
) => {
  return [
    `/api/admin/analytics/${gymId}/peak-hours`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAnalyticsPeakHoursQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsPeakHours>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetAnalyticsPeakHoursParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsPeakHours>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsPeakHoursQueryKey(gymId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsPeakHours>>
  > = ({ signal }) =>
    getAnalyticsPeakHours(gymId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsPeakHours>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsPeakHoursQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsPeakHours>>
>;
export type GetAnalyticsPeakHoursQueryError = ErrorType<unknown>;

/**
 * @summary Peak booking hours heatmap
 */

export function useGetAnalyticsPeakHours<
  TData = Awaited<ReturnType<typeof getAnalyticsPeakHours>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetAnalyticsPeakHoursParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsPeakHours>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsPeakHoursQueryOptions(
    gymId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Revenue breakdown
 */
export const getGetAnalyticsRevenueBreakdownUrl = (
  gymId: string,
  params?: GetAnalyticsRevenueBreakdownParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics/${gymId}/revenue-breakdown?${stringifiedParams}`
    : `/api/admin/analytics/${gymId}/revenue-breakdown`;
};

export const getAnalyticsRevenueBreakdown = async (
  gymId: string,
  params?: GetAnalyticsRevenueBreakdownParams,
  options?: RequestInit,
): Promise<RevenueBreakdown> => {
  return customFetch<RevenueBreakdown>(
    getGetAnalyticsRevenueBreakdownUrl(gymId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAnalyticsRevenueBreakdownQueryKey = (
  gymId: string,
  params?: GetAnalyticsRevenueBreakdownParams,
) => {
  return [
    `/api/admin/analytics/${gymId}/revenue-breakdown`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAnalyticsRevenueBreakdownQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetAnalyticsRevenueBreakdownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnalyticsRevenueBreakdownQueryKey(gymId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>
  > = ({ signal }) =>
    getAnalyticsRevenueBreakdown(gymId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsRevenueBreakdownQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>
>;
export type GetAnalyticsRevenueBreakdownQueryError = ErrorType<unknown>;

/**
 * @summary Revenue breakdown
 */

export function useGetAnalyticsRevenueBreakdown<
  TData = Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  params?: GetAnalyticsRevenueBreakdownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsRevenueBreakdown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsRevenueBreakdownQueryOptions(
    gymId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trainer utilization stats
 */
export const getGetAnalyticsTrainerUtilizationUrl = (gymId: string) => {
  return `/api/admin/analytics/${gymId}/trainer-utilization`;
};

export const getAnalyticsTrainerUtilization = async (
  gymId: string,
  options?: RequestInit,
): Promise<TrainerUtilization[]> => {
  return customFetch<TrainerUtilization[]>(
    getGetAnalyticsTrainerUtilizationUrl(gymId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAnalyticsTrainerUtilizationQueryKey = (gymId: string) => {
  return [`/api/admin/analytics/${gymId}/trainer-utilization`] as const;
};

export const getGetAnalyticsTrainerUtilizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsTrainerUtilizationQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>
  > = ({ signal }) =>
    getAnalyticsTrainerUtilization(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsTrainerUtilizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>
>;
export type GetAnalyticsTrainerUtilizationQueryError = ErrorType<unknown>;

/**
 * @summary Trainer utilization stats
 */

export function useGetAnalyticsTrainerUtilization<
  TData = Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsTrainerUtilization>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsTrainerUtilizationQueryOptions(
    gymId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Platform-wide KPIs
 */
export const getGetSuperadminDashboardUrl = () => {
  return `/api/superadmin/dashboard`;
};

export const getSuperadminDashboard = async (
  options?: RequestInit,
): Promise<SuperadminDashboard> => {
  return customFetch<SuperadminDashboard>(getGetSuperadminDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSuperadminDashboardQueryKey = () => {
  return [`/api/superadmin/dashboard`] as const;
};

export const getGetSuperadminDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperadminDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSuperadminDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperadminDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperadminDashboard>>
  > = ({ signal }) => getSuperadminDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperadminDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuperadminDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperadminDashboard>>
>;
export type GetSuperadminDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Platform-wide KPIs
 */

export function useGetSuperadminDashboard<
  TData = Awaited<ReturnType<typeof getSuperadminDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSuperadminDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSuperadminDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all gyms
 */
export const getListAllGymsUrl = () => {
  return `/api/superadmin/gyms`;
};

export const listAllGyms = async (options?: RequestInit): Promise<Gym[]> => {
  return customFetch<Gym[]>(getListAllGymsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAllGymsQueryKey = () => {
  return [`/api/superadmin/gyms`] as const;
};

export const getListAllGymsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllGymsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllGyms>>> = ({
    signal,
  }) => listAllGyms({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllGyms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllGymsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllGyms>>
>;
export type ListAllGymsQueryError = ErrorType<unknown>;

/**
 * @summary List all gyms
 */

export function useListAllGyms<
  TData = Awaited<ReturnType<typeof listAllGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllGymsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create gym manually
 */
export const getCreateGymAdminUrl = () => {
  return `/api/superadmin/gyms`;
};

export const createGymAdmin = async (
  onboardGymInput: OnboardGymInput,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getCreateGymAdminUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(onboardGymInput),
  });
};

export const getCreateGymAdminMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGymAdmin>>,
    TError,
    { data: BodyType<OnboardGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGymAdmin>>,
  TError,
  { data: BodyType<OnboardGymInput> },
  TContext
> => {
  const mutationKey = ["createGymAdmin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGymAdmin>>,
    { data: BodyType<OnboardGymInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createGymAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGymAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGymAdmin>>
>;
export type CreateGymAdminMutationBody = BodyType<OnboardGymInput>;
export type CreateGymAdminMutationError = ErrorType<unknown>;

/**
 * @summary Create gym manually
 */
export const useCreateGymAdmin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGymAdmin>>,
    TError,
    { data: BodyType<OnboardGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGymAdmin>>,
  TError,
  { data: BodyType<OnboardGymInput> },
  TContext
> => {
  return useMutation(getCreateGymAdminMutationOptions(options));
};

/**
 * @summary Gym detail
 */
export const getGetSuperadminGymUrl = (id: string) => {
  return `/api/superadmin/gyms/${id}`;
};

export const getSuperadminGym = async (
  id: string,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getGetSuperadminGymUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSuperadminGymQueryKey = (id: string) => {
  return [`/api/superadmin/gyms/${id}`] as const;
};

export const getGetSuperadminGymQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperadminGym>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSuperadminGym>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuperadminGymQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperadminGym>>
  > = ({ signal }) => getSuperadminGym(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperadminGym>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuperadminGymQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperadminGym>>
>;
export type GetSuperadminGymQueryError = ErrorType<unknown>;

/**
 * @summary Gym detail
 */

export function useGetSuperadminGym<
  TData = Awaited<ReturnType<typeof getSuperadminGym>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSuperadminGym>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSuperadminGymQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update gym
 */
export const getUpdateSuperadminGymUrl = (id: string) => {
  return `/api/superadmin/gyms/${id}`;
};

export const updateSuperadminGym = async (
  id: string,
  updateGymInput: UpdateGymInput,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getUpdateSuperadminGymUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGymInput),
  });
};

export const getUpdateSuperadminGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSuperadminGym>>,
    TError,
    { id: string; data: BodyType<UpdateGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSuperadminGym>>,
  TError,
  { id: string; data: BodyType<UpdateGymInput> },
  TContext
> => {
  const mutationKey = ["updateSuperadminGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSuperadminGym>>,
    { id: string; data: BodyType<UpdateGymInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSuperadminGym(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSuperadminGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSuperadminGym>>
>;
export type UpdateSuperadminGymMutationBody = BodyType<UpdateGymInput>;
export type UpdateSuperadminGymMutationError = ErrorType<unknown>;

/**
 * @summary Update gym
 */
export const useUpdateSuperadminGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSuperadminGym>>,
    TError,
    { id: string; data: BodyType<UpdateGymInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSuperadminGym>>,
  TError,
  { id: string; data: BodyType<UpdateGymInput> },
  TContext
> => {
  return useMutation(getUpdateSuperadminGymMutationOptions(options));
};

/**
 * @summary Suspend gym
 */
export const getSuspendGymUrl = (id: string) => {
  return `/api/superadmin/gyms/${id}/suspend`;
};

export const suspendGym = async (
  id: string,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getSuspendGymUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getSuspendGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suspendGym>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof suspendGym>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["suspendGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof suspendGym>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return suspendGym(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SuspendGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof suspendGym>>
>;

export type SuspendGymMutationError = ErrorType<unknown>;

/**
 * @summary Suspend gym
 */
export const useSuspendGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suspendGym>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof suspendGym>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getSuspendGymMutationOptions(options));
};

/**
 * @summary Activate gym
 */
export const getActivateGymUrl = (id: string) => {
  return `/api/superadmin/gyms/${id}/activate`;
};

export const activateGym = async (
  id: string,
  options?: RequestInit,
): Promise<Gym> => {
  return customFetch<Gym>(getActivateGymUrl(id), {
    ...options,
    method: "PUT",
  });
};

export const getActivateGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateGym>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateGym>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["activateGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateGym>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return activateGym(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateGym>>
>;

export type ActivateGymMutationError = ErrorType<unknown>;

/**
 * @summary Activate gym
 */
export const useActivateGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateGym>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateGym>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getActivateGymMutationOptions(options));
};

/**
 * @summary List all users
 */
export const getListAllUsersUrl = () => {
  return `/api/superadmin/users`;
};

export const listAllUsers = async (
  options?: RequestInit,
): Promise<UserProfile[]> => {
  return customFetch<UserProfile[]>(getListAllUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAllUsersQueryKey = () => {
  return [`/api/superadmin/users`] as const;
};

export const getListAllUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllUsers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllUsers>>> = ({
    signal,
  }) => listAllUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllUsers>>
>;
export type ListAllUsersQueryError = ErrorType<unknown>;

/**
 * @summary List all users
 */

export function useListAllUsers<
  TData = Awaited<ReturnType<typeof listAllUsers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Platform revenue report
 */
export const getGetPlatformRevenueUrl = () => {
  return `/api/superadmin/revenue`;
};

export const getPlatformRevenue = async (
  options?: RequestInit,
): Promise<PlatformRevenue> => {
  return customFetch<PlatformRevenue>(getGetPlatformRevenueUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformRevenueQueryKey = () => {
  return [`/api/superadmin/revenue`] as const;
};

export const getGetPlatformRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformRevenue>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformRevenue>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformRevenueQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformRevenue>>
  > = ({ signal }) => getPlatformRevenue({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformRevenue>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformRevenue>>
>;
export type GetPlatformRevenueQueryError = ErrorType<unknown>;

/**
 * @summary Platform revenue report
 */

export function useGetPlatformRevenue<
  TData = Awaited<ReturnType<typeof getPlatformRevenue>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformRevenue>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformRevenueQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Issue scoped JWT for gym
 */
export const getImpersonateGymUrl = (gymId: string) => {
  return `/api/superadmin/impersonate/${gymId}`;
};

export const impersonateGym = async (
  gymId: string,
  options?: RequestInit,
): Promise<TokenResponse> => {
  return customFetch<TokenResponse>(getImpersonateGymUrl(gymId), {
    ...options,
    method: "POST",
  });
};

export const getImpersonateGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonateGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof impersonateGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  const mutationKey = ["impersonateGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof impersonateGym>>,
    { gymId: string }
  > = (props) => {
    const { gymId } = props ?? {};

    return impersonateGym(gymId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImpersonateGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof impersonateGym>>
>;

export type ImpersonateGymMutationError = ErrorType<unknown>;

/**
 * @summary Issue scoped JWT for gym
 */
export const useImpersonateGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonateGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof impersonateGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  return useMutation(getImpersonateGymMutationOptions(options));
};

/**
 * @summary Get Stream Chat token for authenticated user
 */
export const getGetChatTokenUrl = () => {
  return `/api/chat/token`;
};

export const getChatToken = async (
  options?: RequestInit,
): Promise<ChatTokenResponse> => {
  return customFetch<ChatTokenResponse>(getGetChatTokenUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGetChatTokenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChatToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getChatToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getChatToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getChatToken>>,
    void
  > = () => {
    return getChatToken(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetChatTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof getChatToken>>
>;

export type GetChatTokenMutationError = ErrorType<void>;

/**
 * @summary Get Stream Chat token for authenticated user
 */
export const useGetChatToken = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChatToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getChatToken>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGetChatTokenMutationOptions(options));
};

/**
 * @summary Get chat channels for the authenticated user
 */
export const getGetMyChatChannelsUrl = () => {
  return `/api/chat/channels`;
};

export const getMyChatChannels = async (
  options?: RequestInit,
): Promise<ChatChannel[]> => {
  return customFetch<ChatChannel[]>(getGetMyChatChannelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyChatChannelsQueryKey = () => {
  return [`/api/chat/channels`] as const;
};

export const getGetMyChatChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyChatChannels>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyChatChannels>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyChatChannelsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyChatChannels>>
  > = ({ signal }) => getMyChatChannels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyChatChannels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyChatChannelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyChatChannels>>
>;
export type GetMyChatChannelsQueryError = ErrorType<void>;

/**
 * @summary Get chat channels for the authenticated user
 */

export function useGetMyChatChannels<
  TData = Awaited<ReturnType<typeof getMyChatChannels>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyChatChannels>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyChatChannelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get active chat channels for a gym (admin only)
 */
export const getGetGymChatChannelsUrl = (gymId: string) => {
  return `/api/chat/gym/${gymId}/channels`;
};

export const getGymChatChannels = async (
  gymId: string,
  options?: RequestInit,
): Promise<ChatChannel[]> => {
  return customFetch<ChatChannel[]>(getGetGymChatChannelsUrl(gymId), {
    ...options,
    method: "GET",
  });
};

export const getGetGymChatChannelsQueryKey = (gymId: string) => {
  return [`/api/chat/gym/${gymId}/channels`] as const;
};

export const getGetGymChatChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGymChatChannels>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymChatChannels>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGymChatChannelsQueryKey(gymId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGymChatChannels>>
  > = ({ signal }) => getGymChatChannels(gymId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!gymId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGymChatChannels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGymChatChannelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGymChatChannels>>
>;
export type GetGymChatChannelsQueryError = ErrorType<unknown>;

/**
 * @summary Get active chat channels for a gym (admin only)
 */

export function useGetGymChatChannels<
  TData = Awaited<ReturnType<typeof getGymChatChannels>>,
  TError = ErrorType<unknown>,
>(
  gymId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGymChatChannels>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGymChatChannelsQueryOptions(gymId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List student's home gyms
 */
export const getGetStudentGymsUrl = () => {
  return `/api/student/gyms`;
};

export const getStudentGyms = async (
  options?: RequestInit,
): Promise<StudentGymEntry[]> => {
  return customFetch<StudentGymEntry[]>(getGetStudentGymsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStudentGymsQueryKey = () => {
  return [`/api/student/gyms`] as const;
};

export const getGetStudentGymsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStudentGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentGymsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentGyms>>> = ({
    signal,
  }) => getStudentGyms({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentGyms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStudentGymsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentGyms>>
>;
export type GetStudentGymsQueryError = ErrorType<unknown>;

/**
 * @summary List student's home gyms
 */

export function useGetStudentGyms<
  TData = Awaited<ReturnType<typeof getStudentGyms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStudentGyms>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStudentGymsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a home gym
 */
export const getAddStudentGymUrl = () => {
  return `/api/student/gyms`;
};

export const addStudentGym = async (
  addStudentGymBody: AddStudentGymBody,
  options?: RequestInit,
): Promise<StudentGymEntry> => {
  return customFetch<StudentGymEntry>(getAddStudentGymUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addStudentGymBody),
  });
};

export const getAddStudentGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStudentGym>>,
    TError,
    { data: BodyType<AddStudentGymBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addStudentGym>>,
  TError,
  { data: BodyType<AddStudentGymBody> },
  TContext
> => {
  const mutationKey = ["addStudentGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addStudentGym>>,
    { data: BodyType<AddStudentGymBody> }
  > = (props) => {
    const { data } = props ?? {};

    return addStudentGym(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddStudentGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof addStudentGym>>
>;
export type AddStudentGymMutationBody = BodyType<AddStudentGymBody>;
export type AddStudentGymMutationError = ErrorType<unknown>;

/**
 * @summary Add a home gym
 */
export const useAddStudentGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStudentGym>>,
    TError,
    { data: BodyType<AddStudentGymBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addStudentGym>>,
  TError,
  { data: BodyType<AddStudentGymBody> },
  TContext
> => {
  return useMutation(getAddStudentGymMutationOptions(options));
};

/**
 * @summary Remove a home gym
 */
export const getRemoveStudentGymUrl = (gymId: string) => {
  return `/api/student/gyms/${gymId}`;
};

export const removeStudentGym = async (
  gymId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveStudentGymUrl(gymId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveStudentGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStudentGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  const mutationKey = ["removeStudentGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStudentGym>>,
    { gymId: string }
  > = (props) => {
    const { gymId } = props ?? {};

    return removeStudentGym(gymId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStudentGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStudentGym>>
>;

export type RemoveStudentGymMutationError = ErrorType<unknown>;

/**
 * @summary Remove a home gym
 */
export const useRemoveStudentGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStudentGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  return useMutation(getRemoveStudentGymMutationOptions(options));
};

/**
 * @summary Set a gym as primary
 */
export const getSetStudentPrimaryGymUrl = (gymId: string) => {
  return `/api/student/gyms/${gymId}/primary`;
};

export const setStudentPrimaryGym = async (
  gymId: string,
  options?: RequestInit,
): Promise<StudentGymEntry> => {
  return customFetch<StudentGymEntry>(getSetStudentPrimaryGymUrl(gymId), {
    ...options,
    method: "PUT",
  });
};

export const getSetStudentPrimaryGymMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStudentPrimaryGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setStudentPrimaryGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  const mutationKey = ["setStudentPrimaryGym"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setStudentPrimaryGym>>,
    { gymId: string }
  > = (props) => {
    const { gymId } = props ?? {};

    return setStudentPrimaryGym(gymId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetStudentPrimaryGymMutationResult = NonNullable<
  Awaited<ReturnType<typeof setStudentPrimaryGym>>
>;

export type SetStudentPrimaryGymMutationError = ErrorType<unknown>;

/**
 * @summary Set a gym as primary
 */
export const useSetStudentPrimaryGym = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStudentPrimaryGym>>,
    TError,
    { gymId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setStudentPrimaryGym>>,
  TError,
  { gymId: string },
  TContext
> => {
  return useMutation(getSetStudentPrimaryGymMutationOptions(options));
};

/**
 * @summary Get trainer availability across student's home gyms
 */
export const getGetStudentMasterCalendarUrl = (
  params?: GetStudentMasterCalendarParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/student/master-calendar?${stringifiedParams}`
    : `/api/student/master-calendar`;
};

export const getStudentMasterCalendar = async (
  params?: GetStudentMasterCalendarParams,
  options?: RequestInit,
): Promise<MasterCalendarResponse> => {
  return customFetch<MasterCalendarResponse>(
    getGetStudentMasterCalendarUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStudentMasterCalendarQueryKey = (
  params?: GetStudentMasterCalendarParams,
) => {
  return [`/api/student/master-calendar`, ...(params ? [params] : [])] as const;
};

export const getGetStudentMasterCalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentMasterCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStudentMasterCalendarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMasterCalendar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentMasterCalendarQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentMasterCalendar>>
  > = ({ signal }) =>
    getStudentMasterCalendar(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentMasterCalendar>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStudentMasterCalendarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentMasterCalendar>>
>;
export type GetStudentMasterCalendarQueryError = ErrorType<unknown>;

/**
 * @summary Get trainer availability across student's home gyms
 */

export function useGetStudentMasterCalendar<
  TData = Awaited<ReturnType<typeof getStudentMasterCalendar>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStudentMasterCalendarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMasterCalendar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStudentMasterCalendarQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
